//TODO: probably want to get this smarter-- maybe from an API? need to version as well

const data = {
    version: "2.0",  // version of mutant city blues
    pointPoolGeneral: 60,
    pointPoolMutantPowers: 30,
    pointPoolInvestigative: 14, //TODO: this depends on number of players.
    numPlayersToInvestigativePoints: {
        "2": 18,
        "3": 14,
        "4": 12,
        "5+": 10
    },
    investigativeAbilities: [
        {
            id: 1,
            name: "Anamorphology",
            category: "Technical",
            description: "Anamorphology is the study of mutant powers. "
                + "You can identify an individual's mutant powers from a DNA sample, "
                + " spot the  signs of mutant organs and appendages (including gills, fangs, stingers, and natural weaponry),"
                + " tell when a subject is using a non-obvious power and surmise what is being done."
        },
        {
            id: 2,
            name: "Anthropology",
            category: "Academic",
            description: "You are an expert in the study of human cultures, from " +
"the stone age to the internet age. You can: " +
"identify artifacts and rituals of living cultures, " +
"describe the customs of a foreign group or local " +
"subculture, " +
"intelligently analyze academic treatises on crime rates, " +
"the effects of incarceration and other topics related to " +
"policing, " +
"extrapolate the practices of an unknown culture from " +
"similar examples, " +
"guess at power structures and subfactions within a " +
"group - identifying, say, a gang leader, or the most " +
"influential person in a neighborhood, or " +
"spot cultural trends and influence."
        },
        {
            id: 3,
            name: "Architecture",
            category: "Academic",
            description: "You know how buildings are planned and constructed. " +
                "You can: " +
                "guess what lies around the corner while exploring an " +
                "unknown structure, " +
                "judge the relative strength of building materials, " +
                "identify a building's age, architectural style, original " +
                "use, and history of modifications, " +
                "construct stable makeshift structures, or " +
                "identify elements vital to a building's structural " +
                "integrity."
        },
        {
            id: 4,
            name: "Art History",
            category: "Academic",
            description: "You're an expert on works of art from an aesthetic and " +
"technical point of view. You can: " +
"distinguish real works from fakes, " +
"tell when something has been retouched or altered, " +
"identify the age of an object by style and materials, or " +
"call to mind historical details on artists and those " +
"around them. " +
"You also have connections in the art world: you know the " +
"market, the dealers, and the fences."
        },
        {
            id: 5,
            name: "Ballistics",
            category: "Technical",
            description: "You process evidence relating to the use of firearms. You " +
"can: " +
"identify the caliber and type of a bullet or casing " +
"found at a crime scene, " +
"determine whether a particular gun fired a given " +
"bullet, " +
"trace the ownership of a particular firearm, " +
"or identify unusual weapons, and guess at the sort " +
"of criminal group who might employ a particular " +
"weapon (\"the Bosnian cartels use that sort of gun\")."
        },
        {
            id: 6,
            name: "Bullshit Detector",
            category: "Interpersonal",
            description: "You can tell when people are lying. You must usually be " +
"interacting with them or observing them from a close " +
"distance, but sometimes you can spot liars on television, " +
"too. Unfortunately, nearly everyone lies, especially when " +
"facing possible trouble from the authorities. Sometimes " +
"you can infer why they're lying, but it's hard to reliably " +
"discern motive or get at the facts they're working to " +
"obscure. " +
"Not all lies are verbal. You can tell when a person is " +
"attempting to project a false impression through body " +
"language. " +
"Certain individuals may be so adept at lying that they " +
"never set off your bullshit detector. Some people believe " +
"their own falsehoods. Psychopathic personality types " +
"lie reflexively and without shame, depriving you of the " +
"telltale tics and gestures you use to sense when a person " +
"is deceiving you. " +
"In play, the most important use of Bullshit Detector " +
"is to cut off unprofitable lines of investigation. The GM " +
"will ensure that you can tell when a particular suspect has " +
"given you everything you need to know, or that you can " +
"rely on a witness' testimony in your investigation. " +
"With a Push of Bullshit Detector, you may be able to " +
"identify exactly what they're lying about."
        },
        {
            id: 7,
            name: "Bureaucracy",
            category: "Interpersonal",
            description: "You know how to navigate a bureaucratic organization, " +
"whether it's a governmental office or a large business " +
"concern. You know how to get what you want from it in " +
"an expeditious manner, and with a minimum of ruffled " +
"feathers. You can: " +
"convince officials to provide sensitive information, " +
"gain credentials on false pretenses, " +
"find the person who really knows what's going on, " +
"locate offices and files, " +
"or borrow equipment or supplies. " +
"Bureaucracy is not a catch-all information gathering " +
"ability. Bureaucrats wish to convey the impression that " +
"they are busy and harried, whether or not they actually " +
"are. Most take a profound, secret joy in directing inquiries " +
"elsewhere. When players attempt to use Bureaucracy to " +
"gain information more easily accessible via other abilities " +
"(such as Research), their contacts snidely advise them to " +
"do their own damn legwork. A Push can get you more " +
"assistance from staff. " +
"This ability also covers your own expertise in dealing " +
"with paperwork and police administration. If you need to " +
"fill out lots of forms, or pull strings to get something done " +
"within the system, use Bureaucracy."
        },
        {
            id: 8,
            name: "Charm",
            category: "Interpersonal",
            description: "You're good at getting people to help you by " +
"complimenting them, as subtly or blatantly as they prefer. " +
"You can get them to: " +
"reveal information, " +
"perform minor favors, " +
"or regard you as trustworthy. " +
"This ability also covers flirting with people who find you " +
"sexually attractive, and exploiting this attraction to get " +
"them to reveal information."
        },
        {
            id: 9,
            name: "Chemistry",
            category: "Technical",
            description: "You're trained in the analysis of chemical substances. " +
"You can: " +
"among a wide variety of other materials, identify " +
"drugs, pharmaceuticals, toxins, and viruses, " +
"match samples of dirt or vegetation from a piece of " +
"evidence to a scene, " +
"match paint flecks and other physical evidence, " +
"or test for the presence of various substances."
        },
        {
            id: 10,
            name: "Community Relations",
            category: "Interpersonal",
            description: "You're practiced at projecting an impression of " +
"competence, trustworthiness and media-savvy heroism. " +
"Middle-class, law-abiding civilians see you as a good, " +
"upstanding cop and are willing to help you with your " +
"inquiries. (Compare Streetwise, p. 27). You can: " +
"quickly and efficiently elicit information from " +
"witnesses, " +
"inspire witnesses to come forward and volunteer what " +
"they saw, " +
"reassure people or disperse crowds of bystanders, " +
"or navigate newspaper or other media interviews without " +
"embarrassing yourself or the department."
        },
        {
            id: 11,
            name: "Cop Talk",
            category: "Interpersonal",
            description: "You know how to speak the lingo of police officers, and to " +
"make them feel confident and relaxed in your presence. " +
"You can: " +
"coolly ply cops for confidential information, " +
"get excused for minor infractions, " +
"demonstrate you are a colleague, " +
"navigate both official regulations and unspoken " +
"customs, or " +
"pick up on gossip and intrigue within the department."
        },
        {
            id: 12,
            name: "Criminology",
            category: "Academic",
            description: "You've studied the history and sociology of crime, " +
"especially international organized criminal syndicates; " +
"you're a crime nerd. You're familiar with obscure " +
"criminal groups and techniques, famous cases and " +
"criminals, and you stay current with bulletins and reports " +
"from international agencies like Interpol. You can: " +
"identify international criminals and their connections, " +
"known or suspected, " +
"identify cases where a major criminal syndicate may " +
"be involved, or " +
"liaise with federal and international enforcement " +
"agencies."
        },
        {
            id: 13,
            name: "Cryptography",
            category: "Technical",
            description: "You're an expert in the making and breaking of codes, " +
"from the simple ciphers of old-school espionage tradecraft " +
"to the supercomputer algorithms of the present day."
        },
        {
            id: 14,
            name: "Data Retrieval",
            category: "Technical",
            description: "You use computer and electronic technology to retrieve " +
"and enhance information on hard drives and other " +
"media. You can: " +
"recover hidden, erased or corrupted computer files, " +
"increase the clarity of audio recordings, zeroing in on " +
"desired elements, " +
"miraculously find detailed, high-resolution images " +
"within a blurry video or JPEG, or " +
"rapidly locate and copy relevant information from a " +
"hard drive or computer system."
        },
        {
            id: 15,
            name: "Document Analysis",
            category: "Technical",
            description: "You're an expert in the study of documents, both physical " +
"and electronic. You can: " +
"determine a document's approximate age from " +
"physical or stylistic clues, " +
"identify the manufacturer of paper used in a " +
"document, or the printer that printed onto it, " +
"evaluate the writer's mindset and intent, " +
"tell forged documents from the real thing, " +
"identify distinctive handwriting and writing styles, or " +
"examine metadata and trace images. " +
"You may be able to identify the distinctive style of a " +
"particular forgery - you can tell if a fake ID was made " +
"by a teenager, or by a particular criminal gang, or by a " +
"foreign intelligence service"
        },
        {
            id: 16,
            name: "Electronic Surveillance",
            category: "Technical",
            description: "You're adept at the use of sound recording equipment to " +
"gather evidence. You can: " +
"trace phone calls, " +
"plant secret listening devices or operate a directional " +
"microphone, " +
"locate secret listening devices planted by others, " +
"make high-quality audio recordings, " +
"enhance the quality of audio recordings, isolating " +
"chosen sounds, " +
"or handle the technical side of wiretaps, pen registers, "  +
"email taps and other modern surveillance methods."
        },
        {
            id: 17,
            name: "Energy Residue Anaylsis",
            category: "Technical",
            description: "By studying debris and damaged objects found at a scene, " +
"you can tell what blast powers (or other mutant abilities) " +
"were used to damage them. You can also distinguish " +
"items damaged by mutant powers from those destroyed " +
"by naturally-occurring incidents of similar sources. For " +
"example, you can examine a rooftop and determine first " +
"of all that it was struck by lightning, and second of all, " +
"that the lightning was generated by a mutant and was " +
"not a storm effect."
        },
        {
            id: 18,
            name: "Evidence Collection",
            category: "Technical",
            description: "You're adept at finding, bagging and tagging important " +
"clues. You can: " +
"spot objects of interest at a crime scene or other " +
"investigation site, " +
"note relationships between objects at a crime scene, " +
"reconstructing sequences of events, " +
"or store objects for forensic analysis without " +
"contaminating your samples."
        },
        {
            id: 19,
            name: "Explosive Devices",
            category: "Technical",
            description: "You're an expert in bombs and booby-traps. You can: " +
"defuse bombs and traps, " +
"reconstruct exploded bombs, determining their " +
"materials, manufacture, and the sophistication of the " +
"bomb-maker, or " +
"safely construct and detonate explosive devices of " +
"your own."
        },
        {
            id: 20,
            name: "Fingerprinting",
            category: "Technical",
            description: "You're an expert in finding, transferring and matching " +
"fingerprints. This includes expertise in the computer " +
"software used to compare sample fingerprints against " +
"large databases of criminal defendants and government " +
"personnel."
        },
        {
            id: 21,
            name: "Forensic Accounting",
            category: "Academic",
            description: "You comb through financial data looking for irregularities. " +
"In the words made famous during Woodward and " +
"Bernstein's investigation of the Watergate scandal, you " +
"know how to \"follow the money.\" You can: " +
"tell legitimate businesses from criminal enterprises, " +
"spot the telltale signs of embezzlement, " +
"or track payments to their source."
        },
        {
            id: 22,
            name: "Forensic Anthropolgy",
            category: "Technical",
            description: "You perform autopsies on deceased " +
"subjects to determine their cause of " +
"death. In the case of death by foul " +
"play, your examination can identify: " +
"the nature of the weapon or weapons used, " + 
"the presence of intoxicants or other foreign substances in the bloodstream, " +
"the contents of the victim's last meal, " +
"the approximate time of death, or " +
"the crime scene, in the case of a dumped body. " +
"In many cases, you can reconstruct the sequence of events leading to the " +
"victim's death from the arrangement of wounds on the body. " +
"You also perform DNA analysis on samples found at crime scenes, " +
"matching them to samples provided " +
"by suspects."
        },
        {
            id: 23,
            name: "Forensic Psychology",
            category: "Academic",
            description: "You apply psychological insight to " +
"the solving of criminal cases. From " +
"the details of a crime scene, you can, based on past case " +
"studies of similar offenses, assemble a profile detailing " +
"the perpetrator's likely personal history, age, habits and attitudes. " +
"You can also glean useful information from simple " +
"observation of individuals, especially as they react to pressure."
        },
        {
            id: 24,
            name: "History",
            category: "Academic",
            description: "You're an expert in recorded human history, with an " +
"emphasis on its political, military, and economic and " +
                "technological developments. You can: " +
            "recognize obscure historical allusions, " +
"identify artifacts by culture and usage, " +
"distinguish real artifacts from fakes, " +
"recall capsule biographies of famous historical figures, " +
"tell where and when an object made during historical times was fashioned, or " +
"identify the period of an article of dress or costume."
        },
        {
            id: 25,
            name: "Impersonate",
            category: "Interpersonal",
            description: "You're good at posing as another person, whether briefly " +
"misrepresenting yourself during a phone call or spending " +
"long periods undercover in a fictional identity. " +
"Successfully disguising yourself as an actual person " +
"known to those you're interacting with is extraordinarily " +
"difficult, and requires a Push in each scene you maintain " +
"the deception."
        },
        {
            id: 26,
            name: "Influence Detection",
            category: "Interpersonal",
            description: "You've been trained in the EMAT Protocol, a series of " +
"observational techniques used to identify signs of mind " +
"control or mental influence. To use them, you must speak " +
"to the subject, making intense eye contact. The apparent " +
"subject matter of the conversation means little to the " +
"outcome: it can be an intense exchange on a serious " +
"subject, or can consist entirely of innocuous small talk. " +
"While speaking, you introduce a series of keywords more " +
"important for their rhythmic effect than their meaning. " +
"By gauging subtle unconscious responses in the subject, " +
"especially eye movements and changes in breathing " +
"pattern, you can tell whether they are currently under " +
"mutant mental influence, or have been in the recent " +
"past. If you're especially fortunate, you can also identify " +
"the particular power used on the subject. (When it is " +
"convenient to the mystery to know the type of power, you " +
"can name it specifically. When it would blow a plot point " +
"best revealed later, you learn of the influence but can't " +
"pinpoint the particular ability used.) " +
"Any power which allows or requires the subject to " +
"defend with a Composure test can be detected with this " +
"ability. These include: Emotion Control, Illusion, Induce " +
"Aggression, Induce Fear, Induce Mental Disorder, " +
"Observe Dreams, Memory Alteration, Nondescript, " +
"Possession, Read Minds, Sexual Chemistry, and Telepathy. " +
"Unfortunately, the EMAT techniques are of no great " +
"help in breaking a subject of mental influence. " +
"You can also identify at a glance people who are Trance Susceptible. " +
"A subject can prevent you from attempting the " +
"EMAT protocol by avoiding eye contact and refusing " +
"to engage you in conversation. This is a telling refusal, " +
"as the protocol usually establishes innocence. It is much " +
"more common for suspects to insist on a protocol, even " +
"when they have not been influenced, than to refuse one."
        },
        {
            id: 27,
            name: "Interrogation",
            category: "Interpersonal",
            description: "You're trained in extracting information from suspects and " +
"witnesses in the context of a formal police-style interview. " +
"This must take place in an official setting, where the " +
"subject is confined or feels under threat of confinement, " +
"and recognizes your authority (whether real or feigned). " +
"Once you have a subject under such conditions, you may " +
"question them thoroughly and incisively, establishing a " +
"timeline of events and illuminating any contradictions " +
"or anomalies in their accounts. You're also trained in " +
"interview techniques, including various mind games, and " +
"can judge the best approach for a particular subject."
        },
        {
            id: 28,
            name: "Intimidation",
            category: "Interpersonal",
            description: "You elicit cooperation from suspects by seeming physically " +
"imposing, invading their personal space, and adopting a " +
"psychologically commanding manner. Intimidation may " +
"involve implied or direct threats of physical violence but " +
"is just as often an act of mental dominance. You can: " +
"gain information, " +
"incline the subject to leave the area, " +
"or quell a subject's desire to attempt violence against you or others."
        },
        {
            id: 29,
            name: "Languages",
            category: "Academic",
            description: "You are an expert in the principles and structures " +
"underlying languages. You can: " +
"given a large enough sample of text, decipher the basic meaning of an unknown language, " +
"identify the languages most similar to an unknown language, or " +
"identify artificial, alien and made-up languages. " +
"You're also verbally fluent and literate in several " +
"languages other than your native tongue. You may specify " +
"some of these when you create your character, or choose " +
"opportunistically in the course of play, revealing that you " +
"just happen to speak Javanese when circumstances require " +
"it. You are not learning the language spontaneously " +
"but revealing a hitherto unmentioned fact about your " +
"character. You may elect to be literate in an ancient " +
"language which is no longer spoken. " +
"The Game Moderator may elect to charge you a Push " +
"if your knowledge of an obscure language is egregiously improbable or convenient."
        },
        {
            id: 30,
            name: "Law",
            category: "Academic",
            description: "You are familiar with the criminal and civil laws of your " +
"home jurisdiction, and broadly acquainted with foreign legal systems. You can: " +
"assess the legal risks attendant on any course of action, " +
"understand lawyerly jargon, " +
"or argue with police and prosecutors."
        },
        {
            id: 31,
            name: "Natural History",
            category: "Academic",
            description: "You study the evolution, behavior, and biology of plants " +
"and animals. You can: " +
"tell when an animal is behaving strangely, " +
"tell whether an animal or plant is natural to a given area, " +
"identify an animal from samples of its hair, blood, bones or other tissue, or " +
"identify a plant from a small sample."
        },
        {
            id: 32,
            name: "Negotiation",
            category: "Interpersonal",
            description: "You are an expert in making deals with others, convincing " +
"them that the best arrangement for you is also the best for " +
"them. You can: " +
"haggle for goods and services, " +
"mediate hostage situations, " +
"or swap favors or information with others."
        },
        {
            id: 33,
            name: "Occult Studies",
            category: "Academic",
            description: "You're an expert in the historical study of magic, " +
"superstition, and hermetic practice from the stone age " +
"to the present. From Satanists to the Golden Dawn, you " +
"know the dates, the places, the controversies, and the " +
"telling anecdotes. You can: " +
"identify the cultural traditions informing a ritual from examining its physical aftermath, " +
"supply historical facts concerning various occult traditions, " +
                "guess the intended effect of a ritual from its physical aftermath, or " +
"identify occult activities as the work of informed practitioners, teenage posers, or � where your " +
"campaign allows it � bona fide occultists."
        },
        {
            id: 34,
            name: "Pharmacy",
            category: "Technical",
            description: "You're able to identify and compound drugs and " +
"medicines. You can: " +
"identify drugs and recognize their side-effects and contra-indications, " +
"identify a drug addict after a brief interaction, " +
"analyze and trace the manufacture of controlled substances, " +
"identify poisons and determine antidotes, " +
"know where to obtain illegal or controlled drugs, " +
"or describe the manufacturing process for different " +
"compounds, and the equipment and chemicals needed."
        },
        {
            id: 35,
            name: "Photography",
            category: "Technical",
            description: "You're proficient in the use of cameras, including still and " +
"video photography. You can: " +
"take useful visual records of crime scenes, " +
"rapidly sort through hours of surveillance camera footage to find a particular individual or vehicle, and " +
"track the target across other camera feeds, " +
"analyze and enhance blurred images, " +
"spot manual retouching or digital manipulation in a " +
"photographic or video image, or " +
"realistically retouch and manipulate images."
        },
        {
            id: 36,
            name: "Popular Culture",
            category: "Academic",
            description: "You're a font of apparently useless information that " +
"would stand you in good stead as a contestant on a quiz " +
"show. You're especially good in the following spheres of interest: " +
"celebrities and entertainment, " +
"sports records and statistics, " +
"geography, " +
"or arts and literature. " +
"This ability also covers current events, names in the news, " +
" scandalous rumors, trending topics on social media and " +
"the like. This catch-all ability also allows you to know any " +
"obscure fact not covered by another GUMSHOE ability."
        },
        {
            id: 37,
            name: "Reassurance",
            category: "Interpersonal",
            description: "You get people to do what you want by putting them at " +
"ease. You can: " +
"elicit information and minor favors, " +
"allay fear or panic in others, " +
"or instill a sense of calm during a crisis."
        },
        {
            id: 38,
            name: "Research",
            category: "Academic",
            description: "You know how to find factual information from books, " +
"records, and official sources. You're as comfortable with " +
"a card catalogue and fiche reader as with an internet " +
"search engine. Your phone brims with exotic and useful contacts."
        },
        {
            id: 39,
            name: "Streetwise",
            category: "Interpersonal",
            description: "You know how to behave among crooks, gang-bangers, " +
"druggies, hookers and other habitu�s of the criminal " +
"underworld. You can: " +
"deploy criminal etiquette to avoid fights and conflicts, " +
"identify unsafe locations and dangerous people, " +
"or gather underworld rumors."
        },
        {
            id: 40,
            name: "Traffic Analysis",
            category: "Technical",
            description: "You can extract patterns from a large mass of data � raw " +
"signals intel, phone metadata, a lot of surveillance tapes. " +
"This lets you: " +
"determine which numbers in a set of phone records called who, when, and likely about what, " +
"dig through shared connections on social media sites " +
"or communications apps to build up a picture of a " +
"suspect's contacts list, " +
"determine which cars in a city's traffic pattern are " +
"driving where, when, and how long they're staying there, " +
"work out routines in a suspect's behavior, or in an " +
"organization, and spot unusual deviations from this baseline, or " +
"assemble a communications or organizational picture " +
"of a social network such as a criminal conspiracy, " +
"drug smuggling ring, smuggling operation or social " +
"contacts of a victim or suspect."
        }
    ],
    generalAbilities: [
        {
            id: 1,
            name: "Athletics",
            freePoints: 0,
            category: "Physical",
            description: "Athletics allows you to perform General acts of physical " +
"derring-do, from running to jumping to dodging " +
"oncoming objects. Any physical action not covered " +
"by another ability probably falls under the rubric of " +
"Athletics."
        },
        {
            id: 2,
            name: "Composure",
            freePoints: 1,
            category: "Presence",
            description: "This is used to resist various mutant powers that affect " +
"the mind, and to keep the emotional crises that afflict " +
"cops and private eyes at bay. As mind control powers can " +
"be powerful, you may wish to invest in a high Composure " +
                "(8 or more) to keep perps from twisting your melon."
        },
        {
            id: 3,
            name: "Driving",
            freePoints: 0,
            category: "Physical",
            description: "You're a skilled defensive driver, capable of wringing high " +
"performance from even the most recalcitrant automobile, " +
"pick-up truck, or van. You can: evade or conduct pursuit, " +
"avoid collisions, or minimize damage from collisions, " +
"spot tampering with a vehicle, " +
"or conduct emergency repairs. " +
"For every rating point above 1 in Driving, you may add " +
"an additional vehicle type to your repertoire. These " +
"include: motorcycle, transport truck, helicopter, or " +
"airplane. You may choose exotic types, like hovercrafts " +
"and tanks, although these are unlikely to see regular use " +
"in an investigation-based game."
        },
        {
            id: 4,
            name: "Filch",
            freePoints: 0,
            category: "Focus",
            description: "Your nimble fingers allow you to unobtrusively " +
"manipulate small objects. You can: " +
"pilfer clues from a crime scene under the very noses of " +
"unsuspecting authorities, " +
"pick pockets, " +
"or plant objects on unsuspecting subjects."
        },
        {
            id: 5,
            name: "Health",
            freePoints: 1,
            category: "Physical",
            description: "Health measures your ability to sustain injuries, resist " +
"infection, and survive the effects of toxins. When you get " +
"hit in the course of a fight, your Health pool is diminished. " +
"A higher Health pool therefore allows you to stay in a " +
"fight longer before succumbing to your injuries. " +
"When your Health pool is depleted, you may be " +
"dazed, wounded, or pushing up the daisies. For more on " +
"this, see \"Exhaustion, Injury and Gruesome Death,\" p. " +
"95."
        },
        {
            id: 6,
            name: "Infiltration",
            freePoints: 0,
            category: "Focus",
            description: "You're good at placing yourself inside places you have no " +
"right to be. You can: " +
"pick locks, " +
"deactivate or evade security systems, " +
"sneak up on suspects and their hideouts, to take them " +
"by surprise, " +
"or find suitable places for forced entry, and use them. " +
"Despite its name, Infiltration is as useful for getting out of " +
"places undetected as it is for getting into them."
        },
        {
            id: 7,
            name: "Mechanics",
            freePoints: 0,
            category: "Focus",
            description: "You're good at building, repairing, and disabling devices,  "+
"from classic pit-and-pendulum traps to DVD players. " +
"Given the right components, you can create jury-rigged " +
"devices from odd bits of scrap. Mechanics doubles as an " +
"Investigative ability when used to: " +
"evaluate the quality of workmanship used to create an " +
"item or " +
"determine the identity of a handmade item's maker by " +
"comparing to known work by that individual."
        },
        {
            id: 8,
            name: "Medic",
            freePoints: 0,
            category: "Focus",
            description: "You can perform first aid on sick or injured individuals. " +
"If someone is Hurt (0 to -5 Health), you can spend " +
"Medic points to treat their wounds. For every Medic " +
"point you spend, they regain 2 Health. You can only do " +
"this to Hurt characters, and cannot restore their Health " +
"above where it was before they incurred this damage. " +
"If you're treating your own injuries, the benefit is " +
"halved: you only regain 1 Health for every point of Medic " +
"spent." +
"If someone is Seriously Injured (-6 to -11 Health), you " +
"can spend 2 points of Medic to stabilize them and stop " +
"them bleeding out, but cannot restore their Health; they " +
"need hospitalization. " +
"You can also use Medic to treat various conditions, " +
    "like poisoning."
        },
        {
            id: 9,
            name: "Preparedness",
            freePoints: 0,
            category: "Presence",
            description: "You expertly anticipate the needs of any mission by " +
"packing a kit efficiently arranged with necessary gear. " +
"Assuming you have immediate access to your kit, you can " +
"produce whatever object the team needs to overcome an " +
"obstacle. You make a simple test (p. 84); if you succeed, " +
    "you have the item you want. You needn't do this in " +
"advance of the adventure, but can dig into your kit bag " +
"(provided you're able to get to it) as the need arises. " +
"Items of obvious utility to a superpowered investigation " +
"do not require a test. These include but are not limited " +
"to: police credentials, handcuffs, note paper, writing " +
"implements, a laptop computer, a cellphone, a mini USB " +
"drive, various types of tape, common tools and hardware, " +
"light weapons, flashlights of various sizes, chem lights, " +
"batteries, magnifying glasses, a thermometer, and a no-frills audio recording device. " +
"Other abilities imply the possession of basic gear " +
"suitable to their core tasks. Characters with Medic have " +
"their own first aid kits; Photographers come with cameras " +
"and accessories. If you have Shooting, you have a gun, and " +
"so on. Preparedness does not intrude into their territory. " +
"It covers general-purpose investigative equipment, plus " +
"oddball items that suddenly come in handy in the course " +
"of the story. " +
"The sorts of items you can produce at a moment's " +
"notice depend not on your rating or pool, but on narrative " +
"credibility. If the GM determines that your possession of " +
"an item would seem ludicrous and/or out of genre, you " +
"don't get to roll for it. You simply don't have it. Any item " +
"which elicits a laugh from the group when suggested is " +
"probably out of bounds. " +
"Inappropriate use of the Preparedness ability is like " +
"pornography. Your GM will know it when they see it."
        },
        {
            id: 10,
            name: "Scuffling",
            freePoints: 0,
            category: "Physical",
            description: "You can hold your own in a hand-to-hand fight, whether " +
"you wish to kill, knock out, restrain, or evade your " +
"opponent. This includes unarmed combat and use of " +
"hand weapons like knives or clubs."
        },
        {
            id: 11,
            name: "Sense Trouble",
            freePoints: 0,
            category: "Presence",
            description: "This ability allows you to perceive (either with sight or " +
"other senses) potential hazards to yourself or others. For " +
"example, you can: " +
"hear the tread of a psycho killer as he sneaks up " +
"behind your cabin, " +
                "see a skulking figure hiding in the high weeds, " +
                "smell the singed shredded clothing of the recently blasted mutant who lies in wait behind the stairs, " +
"spot the metal trapdoor hidden beneath that artfully scattered covering of dead leaves, " +
"or have a bad feeling about that noise the car engine has " +
"been making since you left the rest stop." +
"Players never know the Difficulty Numbers for Sense " +
"Trouble before deciding how many points to spend, even " +
"in games where GMs generously inform the players of " +
"other Difficulty Numbers. Players must blindly choose " +
"how much to spend."
        },
        {
            id: 12,
            name: "Shooting",
            freePoints: 0,
            category: "Physical",
            description: "You are adept with firearms. As well as being able to " +
"shoot accurately, you may have knowledge about models, " +
"availability and maintenance."
        },
        {
            id: 13,
            name: "Surveillance",
            freePoints: 0,
            category: "Presence",
            description: "You're good at following suspects without revealing your " +
"presence. You can: " +
"guide a team to follow a suspect for short periods, " +
"handing off to the next in sequence, so the subject " +
"doesn't realize they're being trailed, " +
"use telescopic viewing equipment to keep watch on a " +
"target from a distance, " +
"find undetectable vantage points, " +
"or hide in plain sight. " +
"8 or more points in Surveillance grants you the " +
"Investigative ability Electronic Surveillance."
        }
    ],
    mutantPowers: [
        {
            id: 1,
            name: "Absorption",
            category: "Presence",
            isInvestigative: false,
            position: [4, 2],
            subPosition: [2, 1],
            description: "You can absorb the powers of other mutants, briefly " +
"wielding them yourself. To do so, you must be touching " +
"the subject, and succeed at an Absorption test. The base " +
"Difficulty equals the subject's pool in the ability you're " +
"attempting to absorb. If, in the immediately previous " +
"combat round, you damaged the subject with your bare " +
"hands, reduce the Difficulty by 25%, rounding up. If " +
"you have just damaged the subject with your Fangs (a " +
"connected power), reduce the Difficulty by 50%. (You " +
"qualify for only one of these reductions.) " +
"If you succeed, you may now wield one of the victim's " +
"powers. You choose which power to absorb. You may " +
"spend 5 Absorption points to rob the victim of the power " +
"until you relinquish it; otherwise they may continue to " +
"access it, too. " +
"If the absorbed power requires or allows you to spend " +
"points to use it, you spend Absorption points as if they " +
"are points in the borrowed ability. " +
"You retain access to the power for an hour. Before it " +
"elapses, you may spend an additional Absorption point " +
"to extend the duration for another hour. " +
"When you absorb an additional power, you must " +
"spend 7 Absorption points, or relinquish all other " +
"absorbed powers you're currently maintaining. You may " +
"relinquish a power at any time, regardless of how far " +
"you are from the person you absorbed it from, or what " +
"barriers lie between you. " +
"If you are reduced to 0 or fewer Health points, all " +
"powers relinquish immediately."
        }, {
            id: 2,
            name: "Alter form",
            category: "Physical",
            isInvestigative: false,
            position: [5, 5],
            subPosition: [4, 2],
            description: "You can change your physical appearance, including " +
"your facial structure, build, weight, coloration, and even " +
"apparent gender. It costs 3 Alter Form points to adopt a " +
"new appearance, plus 1 point for every 15kg of weight " +
"difference between your real form and the adopted one, " +
"and 1 point for every 15cm of height difference. " +
"If the new form is 30 or more kilograms lighter or " +
"heavier than you, or 30cm or more shorter or taller, " +
"your sense of coordination suffers. The Difficulty of all " +
"Athletics, Scuffling and Shooting tests increases by 1. " +
"You remain in the altered form for one hour, after " +
"which point you must spend 1 point per hour to remain " +
"in that form. Returning to your true form costs nothing." +
"You can't convincingly mimic the exact form of a " +
"known person; to do that requires the connected ability " +
"Impersonate. When you alter your form to a member of the opposite " +
"sex, you acquire the outward characteristics, but not the " +
"internal organs to match. " +
"Your new form must fall within the range of human " +
"possibilities: you can't give yourself a wolf head, grow " +
"wings, or replicate the anatomical changes brought on " +
"by other mutant powers."
        },
        {
            id: 3,
            name: "Analytic Taste",
            isInvestigative: true,
            position: [3, 2],
            subPosition: [2, 1],
            description: "Your sense of taste is superhuman, and you have, by " +
"trial and error, trained yourself to use it as a precision " +
"instrument. You function as a walking, talking chemical " +
"analysis lab, able to instantly detect the composition " +
"of nearly any object you can touch your tongue to. " +
"By distinguishing fine gradations of taste, you can, " +
"for example, match a sample of heroin to the precise " +
"batch it came from, or conduct a comparative analysis " +
"of soil samples. Although you may for good reason be " +
"reluctant to do so, you can even identify blood types from " +
"small samples, or derive similar identifying or typing " +
"information from other bodily fluids. " +
"Some individuals with analytic taste suffer from " +
"high revulsion thresholds and can only enjoy the purest, " +
"most perfect foods. Others become inured to traditional " +
"pleasures associated with the sense of taste, or become " +
"passionate connoisseurs of substances ordinary people " +
"consider inedible. " +
"When using this sense, you consume, at most, only " +
"trace quantities of the substances you test. Analytic taste " +
"grants no ability to digest inedible matter. " +
"Although this power grants no poison immunity, only " +
"the most toxic of substances will harm you in the tiny " +
"trace quantities required for analysis."
        },
        {
            id: 4,
            name: "Armor",
            category: "Physical",
            isInvestigative: false,
            position: [2, 2],
            subPosition: [1, 1],
            description: "At will, you can cause your skin to harden to the " +
"consistency of a rhino's hide. Like anyone's, your skin " +
"cells contain a fibrous structural protein called keratin. " +
"This power causes your keratin to swell and harden on " +
"command. Even more so than a real rhino's hide, armor protects " +
"you against kinetic impact, including bullets, blunt force, " +
"unarmed blows in hand to hand combat, as well as " +
"injuries sustained when you fall or get crushed. For every " +
"3 Armor points spent when activating your power, you " +
"reduce any instance of damage from any of those sources " +
"by 1 damage point. " +
"It takes about a minute to activate your armor, and " +
"about ten to relax your keratin back to its normal state. " +
"The armor is extremely itchy; after you've had it activated " +
"for about ten minutes, the discomfort and distraction " +
"you suffer increases the Difficulty of all General ability " +
"tests by 1. The itch recedes five minutes after you've " +
"deactivated your armor."
        },
        {
            id: 5,
            name: "Blade Immunity",
            category: "Physical",
            isInvestigative: false,
            position: [2, 1],
            subPosition: [1, 4],
            description: "When struck with any cutting or stabbing weapon, " +
"including the natural weapons of animals and your fellow " +
"mutants, your skin cells arrange themselves to deflect the " +
"blade of your enemy's weapon. After you are struck with " +
"such a blow, you may spend 1 Blade Immunity point to " +
"reduce the damage dealt to 0."
        }, 
        // 6 is missing by accident, there is no power for 6
        {
            id: 7,
            name: "Blood Spray",
            category: "Physical",
            isInvestigative: false,
            position: [4, 0],
            subPosition: [2, 4],
            description: "You can perform a ranged attack in which you send a " +
"high-pressure spray of your own blood gushing from your " +
"mouth. You hit your target on a successful Blood Spray " +
"test. If you hit, the opponent must make an Athletics test, " +
"the Difficulty of which equals 4 plus any Blood Spray " +
"points you spent on the attack. If they fail the test, they " +
"are knocked over and must, in lieu of their next attack, " +
"make an Athletics test (against the same Difficulty) in " +
"order to regain their footing. If they fail, they continue to " +
"slip on the blood, losing further attacks until they finally succeed. " +
"A blood spray attack inspires instinctive revulsion. " +
"Anyone within direct visual range must make a " +
"Composure test or suffer the urge to flee. Victims with " +
"the Olfactory Center power add your Blood Spray pool " +
"to the Difficulty of this test. " +
"Characters who do not flee suffer ill effects while " +
"they remain able to see and smell your blood: their Hit " +
"Threshold decreases by 1, and the Hit Threshold of " +
"anyone they're attempting to attack effectively increases by 1. " +
"In addition to any Blood Spray points you spend, each " +
"use of this power costs you 3 Health points. Health points " +
"lost to Blood Spray use can be refreshed with a large " +
"meal of red meat, washed down with large quantities of " +
"orange juice or a similarly sugary drink, followed by an hour's nap. " +
"Clever mutants will also find non-combat uses for " +
"this outr� power: for example, to cover the lenses of " +
"inconvenient security cameras."
        },
        {
            id: 8,
            name: "Cognition",
            category: "Focus",
            isInvestigative: false,
            position: [5, 3],
            subPosition: [4, 2],
            description: "Your brain exhibits the raw calculating power of an " +
"advanced supercomputer. You are able to perform " +
"complex mathematical calculations off the top of " +
"your head. You may spend 3 Cognition points to " +
"rapidly accomplish any task involving calculations " +
"and correlating reams of information - in effect, " +
"you can use it to Push abilities like Research or " +
"Traffic Analysis to get the job done faster. " +
"This General ability allows you to identify " +
"moments when players, including yourself, arrive " +
"at an essentially correct interpretation of facts " +
"gathered using your Investigative abilities. You " +
"may at any time spend 3 Cognition points to test " +
"the validity of a theory of the case at hand. The " +
"GM responds by telling you whether the theory is " +
"hot, warm, cold, or freezing. As per the traditional " +
"kid's game of hotter-colder, hot means that you're " +
"correct, or very close to it, and cold means that " +
"you're far from the mark. " +
"The GM may also simply respond that you " +
"haven't got enough information to come up with a " +
"rationally grounded theory. To qualify for analysis " +
"by the Cognition power, the reconstruction of an " +
"event must be reasonably complete. Generally " +
"speaking, it must name a suspect, describe the " +
"method by which the crime was committed, " +
"and stipulate a motive. It must also account for " +
"any puzzling anomalies surrounding the event " +
"you're investigating. Cognition doesn't help you " +
"to identify lucky guesses or tell you, without " +
"evidence, whether a particular likely-seeming " +
"suspect is indeed the perpetrator. " +
"Sometimes a player will lay out a correct " +
"theory of the case and then immediately discard " +
"or forget it. After some time has passed, if the " +
"group continues to head off in a less productive " +
"direction, the GM may tell you that someone at " +
"some point already hit on the correct theory. They " +
"do not specify when this happened, who said it, or " +
"what the theory was. This use of Cognition costs no points."
        },
        {
            id: 9,
            name: "Command Amphibians & Reptiles",
            category: "Presence",
            isInvestigative: false,
            position: [3, 1],
            subPosition: [4, 1],
            description: "You can order amphibians and reptiles to perform simple " +
"tasks in accordance with their instincts and physical " +
"capabilities. You can prompt the creatures to swarm en " +
"masse on a chosen point. Venomous snakes and reptiles " +
"can be induced to bite specific targets. Alligators and " +
"crocodiles can be sent out to attack, or ordered to guard " +
"particular sites as if they contain the animals' own eggs. " +
"With each use of the ability, you may affect any " +
"number of creatures of a given zoological order, within " +
"the range of your power. The orders are: crocodilia, " +
"squamata(lizards and snakes), and testudines(turtles and " +
"tortoises.) Amphibians and reptiles aren't known for their long " +
"attention spans, so lengthy or sustained actions call for " +
"high Difficulty numbers."
        },
        {
            id: 10,
            name: "Command Birds",
            category: "Presence",
            isInvestigative: false,
            position: [1, 3],
            subPosition: [2, 2],
            description: "You can command birds to perform simple tasks in " +
"accordance with their instincts and physical capabilities. " +
"Birds that can be trained, such as hawks and parrots, " +
"can be instantaneously imprinted with more complex " +
"behaviors. These behaviors must be in line with what a " +
"handler could, over time, train the birds to do. You can " +
"get a mynah to repeat a particular phrase, but he'll never " +
"defuse a bomb for you. " +
"With a single use of this power, you can command " +
"any number of birds who normally flock together. In " +
"other words, you can command as many seagulls as can " +
"be found within the ability's range, or a mating pair of " +
"falcons."
        },
        {
            id: 11,
            name: "Command Fish",
            category: "Presence",
            isInvestigative: false,
            position: [1, 4],
            subPosition: [1, 4],
            description: "You can command fish to perform simple tasks in " +
"accordance with their instincts and physical capabilities. " +
"Mostly this means that you can get them to swim en " +
"masse in a particular direction. Predatory fish like sharks " +
"can be induced to attack chosen targets. " +
"With a single use of this power, you can command any " +
"number of fish who normally school together. " +
"If your rating in Command Fish exceeds 8, you can " +
"also command octopuses, squid, lobsters and crayfish. " +
"The octopus exhibits surprising intelligence and can " +
"perform an array of complex underwater tasks."
        },
        {
            id: 12,
            name: "Command Insects",
            category: "Presence",
            isInvestigative: false,
            position: [4, 1],
            subPosition: [2, 1],
            description: "You can command insects, worms, and spiders, within " +
"the highly restrictive limits of their ingrained behavior " +
"and physical capabilities. Mostly this means that you can " +
"get them to move en masse to a particular location. You " +
"can command fireflies to fly together in a lantern-like " +
"grouping, station poisonous spiders where they are likely " +
"to sting interlopers, or send plagues of locusts to strip the " +
"crops of farmers who've aroused your godlike wrath. " +
"With a single use of this power, you can command all " +
"insects within its range."
        },
        {
            id: 13,
            name: "Command Mammals",
            category: "Presence",
            isInvestigative: false,
            position: [3, 6],
            subPosition: [3, 4],
            description: "You can command mammals, within the limits of their " +
"instinctual behavior and physical capabilities. If an " +
"animal is trainable to perform a given task, you can " +
"instantly get it to reproduce this learned behavior, even if " +
"this particular specimen is wild and has never performed it. " +
"You can command as many specimens of a given " +
"species as are found within your ability's range. " +
"While humans are mammals, you can't use this power " +
"on them in most circumstances. At most, you can give a " +
"mild subliminal nudge one way or another."
        },
        {
            id: 14,
            name: "Concussion Beam",
            category: "Focus",
            isInvestigative: false,
            position: [4, 3],
            subPosition: [2, 4],
            description: "This blast power emits a beam of pure kinetic energy, " +
"which hits your opponents with blunt force trauma, " +
"visible as a rippling distortion in the air. You can also " +
"use concussion beams to shove objects around or smash " +
"through barriers. It's impossible to use this power gently; " +
                "even if you try to \"pull your blow\", it's still a strong shove or punch. " +
"Decide during character generation whether the " +
"beam is emitted from your hands or eyes. " +
"Unlike most other blast powers, Concussion Beam is " +
"not countered by High Energy Dispersal, but instead by " +
"Kinetic Energy Dispersal."
        },
        {
            id: 15,
            name: "Cure Disease",
            category: "Presence",
            isInvestigative: false,
            position: [5, 1],
            subPosition: [1, 2],
            description: "By touching an ailing subject, you can cure any disease " +
"caused by infection or bodily degeneration. It cures " +
"mental disorders rooted in physical disorders of the " +
"brain, but not personality disorders, like sociopathy. " +
"The Game Moderator chooses the Difficulty of your " +
"Cure Disease test according to the severity of the illness. " +
"GRFs arising from mutant powers can't be cured " +
"outright, but you can spend Cure Disease points to " +
"assist in a patient's recovery. You can't heal congenital " +
"GRFs; nor does this ability heal wounds, or reverse " +
"damage already visited on a patient by the effects of " +
"illness, such as cardiac arrest or stroke. It can't change a " +
"patient's body morphology, and so can't be used to cure " +
"conditions like chronic obesity. Certain toxins are cured " +
"by Cure Disease; others, by Healing. " +
"The difficulty of your attempt is also the number of " +
"hours before you can use the ability again."
        },
        {
            id: 16,
            name: "Deplete Oxygen",
            category: "Presence",
            isInvestigative: false,
            position: [1, 3],
            subPosition: [4, 4],
            description: "Some people are said to suck the air out of a room. You " +
"are literally capable of this. You can deplete the oxygen " +
"from any area, centered on any point within range. The " +
"approximate size of the area you can deplete determines " +
"the Difficulty of your test. " +
"If you're outdoors, oxygen will diffuse in from the " +
"surrounding air, countering the effect. In an enclosed and " +
"relatively airtight space, people and creatures experience " +
"near-immediate breathing trouble. Those in the area of " +
"effect lose 1 point from each of their General abilities " +
"(except Preparedness) per minute. These are refreshed " +
"after spending as many minutes breathing normally as " +
"they have spent in a state of oxygen deprivation. " +
"Victims in a fully airtight space suffer hypoxia. After " +
"8 minutes, they must make Difficulty 8 Health tests, or " +
"suffer immediate and fatal heart attacks. Survivors must " +
"make additional Health tests every minute thereafter, " +
"with the Difficulty increasing by 2 each time. " +
"Deplete Oxygen confers no immunity to oxygen " +
"deprivation, so if you're in the affected area, you suffer " +
"along with everyone else. " +
"This power immediately quenches all fires within " +
"its area of effect, whether enclosed or not. Neither Fire " +
"Projection or Spontaneous Combustion powers can be " +
"used within an affected area in an enclosed or airtight space."
        },
        {
            id: 17,
            name: "Detect Influence",
            category: "Focus",
            isInvestigative: false,
            position: [6, 3],
            subPosition: [3, 1],
            description: "When any individual within your direct line of sight has " +
"been targeted, successfully or otherwise, by a mutant " +
"power that can be resisted with a Composure test, you " +
"perceive an aura of faintly glowing colorless energy " +
"around them. A trail leads from the aura in the direction " +
"of the mutant using the influence ability; if you can see " +
"the power-user, the trail clearly connects them to their victim. " +
"You must consciously activate this power in order to use it. " +
"Where the discovery of mental influence is not a core " +
"clue that advances the current investigation, make a " +
"Detect Influence test (base Difficulty 4) to see the telltale " +
"aura. If the influencer's rating (not pool) in the power " +
"equals 8 or more, the Difficulty is 5. " +
"If the discovery is a core clue, treat Detect Influence  " +
"as an Investigative ability. If you activate the power, you succeed."
        },
        {
            id: 18,
            name: "Disease Immunity",
            category: "Physical",
            isInvestigative: false,
            position: [5, 1],
            subPosition: [1, 4],
            description: "When making a Health test to resist infectious diseases or " +
"their effects, you may spend 1 Disease Immunity point to " +
"add 3 points to any roll. " +
"Disease Immunity does not protect you from diseases " +
"caused by environmental factors. When your power first " +
"manifested, it cured any congenital or genetic diseases " +
"you might have had. However, it did not protect you from " +
"any GRFs correlated with your mutant powers."
        },
        {
            id: 19,
            name: "Disintegration",
            category: "Focus",
            isInvestigative: false,
            position: [2, 2],
            subPosition: [2, 4],
            description: "This blast power (see sidebar, p. 45) damages objects by " +
"breaking them down at the molecular level. " +
"In addition to the normal combat damage like any " +
"blast power, you can use it to destroy unliving matter. " +
"To do so, make a Disintegration test, with a Difficulty of " +
"1 for every 5kg of matter you wish to destroy. You may " +
"select any object within range. " +
"Disintegrated matter crumbles into a fine dust. " +
"Even a rookie criminalist can spot the telltale signs " +
"of a disintegration wound: they look as if large portions " +
"of tissue have been excised with surgical precision, albeit " +
"in an irregular pattern no surgeon would ever duplicate. " +
"All blood vessels exposed by a disintegration wound " +
"immediately self-cauterize, making it impossible to bleed " +
"out from such an injury. " +
"Disintegration blasts are always lethal damage."
        },
        {
            id: 20,
            name: "Earth Control",
            category: "Focus",
            isInvestigative: false,
            position: [5, 6],
            subPosition: [1, 2],
            description: "You can animate quantities of sand or soil, producing the " +
"following effects. " +
"Earthquake: On a successful Earth Control test " +
"(Difficulty 4), you can cause a small, localized earth " +
"tremor to radiate outwards from any point within range. " +
"The tremor strikes a roughly circular area centered on " +
"your chosen point. The default diameter of the circle is " +
"3m. You may attempt to affect a larger area by testing " +
"against a higher Difficulty, at + 1 Difficulty for each " +
"additional meter of diameter. The affected area must " +
"be composed primarily of sand or soil; you can't cause a " +
"tremor on an expanse of barren rock. " +
"The tremor is strong enough to damage architectural " +
"supports, cause unsecured objects to fall and possibly " +
"shatter, and to throw people to the ground. Anyone in the " +
"tremor zone (including yourself) must make an Athletics " +
"test against the same Difficulty as the Earth Control " +
"test. Those who fail are knocked off their feet and take " +
"damage, with a damage modifier of -2." +
"Sandstorm: You cause loose sand and grit to rise into " +
"the air, filling a roughly globe-shaped area of disturbance " +
"with a diameter of 1m for every Earth Control point you " +
"spend. You can move the center of the sandstorm to any " +
"spot within range. The sandstorm forces all creatures " +
"within the effect (except for you, who are immune to it) " +
"to hunker down and protect their eyes. Characters can " +
"make Composure tests (Difficulty 6) to fight this impulse " +
"and remain standing with eyes open, but Shooting and " +
"the use of ranged powers becomes impossible due to low " +
"visibility, and the Difficulties of all other physical abilities " +
"are increased by 3."
        },
        {
            id: 21,
            name: "Emotion Control",
            category: "Presence",
            isInvestigative: false,
            position: [6, 2],
            subPosition: [3, 1],
            description: "You can alter the mood of any subject within range. " +
"The subject will feel all of the physical signs associated " +
"with the chosen emotion, in addition to its psychological " +
"components. The default difficulty is 2, plus the number " +
"of steps it takes to get from the subject's current emotional " +
                "state to the desired state." +
"Players may describe their character's present moods, " +
"when necessary. The GM may rule that the character's " +
"described behavior better fits another mood - if the PC " +
"has been raging and cursing at an enemy for the past " +
"ten minutes, he's clearly angry, no matter how much " +
"the player claims he's simply reflective. GMs determine " +
"supporting characters' starting moods. " +
"The subject's mood remains as directed for ten " +
"minutes. You can extend this period by spending 1 " +
"Emotion Control point for each additional ten minutes. " +
"Victims questioning their sudden mood swings may " +
"make Composure tests (Difficulty 4); if successful, they " +
"realize that their emotions have been altered by an " +
"outside force. They still feel the emotion, but can restrain " +
"themselves from taking actions based on it. " +
"Legal implications: Attempts to criminalize non-consensual use of Emotion Control have been thrown " +
"into disarray by a Supreme Court ruling. Five out of " +
"nine justices accepted the proposition that the effects of " +
"the power are on a par with those achievable through " +
"normal human interaction. Fearing that this might set a " +
"precedent allowing the laying of charges for any behavior " +
"causing a shift in another's mood, the justices struck " +
"down the law. Civil suits involving the use of this power " +
"have been thrown into doubt but continue to grind their " +
"way through the courts."
        },
        {
            id: 22,
            name: "Empathy",
            category: "Presence",
            isInvestigative: false,
            position: [6, 1],
            subPosition: [3, 1],
            description: "Empathy is a General ability which supplements the " +
"use of your Investigative abilities, particularly your " +
"interpersonal abilities. It enables you to gauge, in real " +
"time, the success of your various interpersonal gambits " +
"during interrogations and other interviews. " +
"Your brain's ability to perceive and process emotional " +
"cues from the people around you has been heightened to " +
"superhuman levels. To a na�ve observer you may seem " +
"like a mind reader, but really you're processing, at nearly " +
"instantaneous speed, a wide variety of overt and subtle " +
"signals as to the moods of the people you're observing. " +
"At any time, you may spend 1 Empathy point to " +
"determine a subject's current prevalent emotional state. " +
"GMs may describe these however they prefer. You can monitor a subject for subtle increases " +
"and decreases in amusement, anxiety, arousal, anger, " +
"or sympathy. Keying in on a subject in this way costs 3 " +
"Empathy points. You must specify a single one of the " +
"aforementioned emotional states. You can then, over " +
"the course of a single scene or conversation, sense every " +
"time that emotional state intensifies or decreases. This " +
"is especially useful during interrogation scenes, when " +
"you or another team member is trying to get a suspect " +
"to crack and sign a confession. By tracking ups and " +
"downs in anxiety level in response to specific comments " +
"and questions, you can tell when your verbal gambits hit " +
"home, and when they backfire, allowing the suspect to " +
"recover their composure. " +
"Individuals suffering from certain mental conditions " +
"are difficult or impossible to read using empathy. " +
"Psychopaths do not exhibit identifiable anxiety or " +
"sympathy. Persons with the Dissociation GRF (or a " +
"similar, non-congenital emotional disorder) may not " +
"register at all. When a subject with Personality Drift or " +
"Meta-Identity Disorder shifts character traits, you lose " +
"your read and must start over again, paying 3 Empathy " +
"points as if you were keying in on an entirely different " +
"person. " +
"Although you will never encounter a situation where " +
"you need Empathy to gather a core clue, a forgiving " +
"GM may allow you to use it in place of an Interpersonal " +
"ability, provided you describe your attempt in a suitably " +
"believable manner. They may, when similarly justified, " +
"also permit you to make interpersonal Pushes using " +
"Empathy points. " +
"Finally, you can also heal Composure damage caused " +
"by traumatic events, and from sources such as Psionic " +
"Blast (p. 61). Each Empathy point spent restores 1 " +
"Composure point to any living subject. Recipients' final " +
"Composure pools may not exceed their Composure " +
"ratings. " +
"Empathy can cure victims slain by psionic blasts. The " +
"Difficulty depends on the time that has elapsed since the " +
"patient died."
        },
        {
            id: 23,
            name: "Endorphin Control (Others)",
            category: "Presence",
            isInvestigative: false,
            position: [5, 1],
            subPosition: [4, 1],
            description: "You can stimulate endorphin production in the brain of " +
"another person within range. The subject experiences an " +
"exhilarating rush of physical pleasure which masks pain " +
"and increases tolerance for risk and danger. " +
"To use the ability, make an Endorphin Control test " +
"against a Difficulty of 3. If the subject's Health pool " +
"equals 8 or more, the Difficulty is 4. " +
"If successful, you may spend X Endorphin Control " +
"(Others) points. The subject gains X Health points and " +
"X Composure points, which may take them beyond their " +
"rating. The effect expires after five minutes, after which " +
"the subject loses X Health and X Composure points. You " +
"can extend this period by spending 1 Endorphin Control " +
"(Others) point for each additional three minutes. " +
"Legal ramifications: Authorities have, with limited " +
"success, attempted to subject willing recipients of " +
"Endorphin Control (Others) to the same legal penalties " +
"faced by heroin users; for more, see \"Dorphing,\" p. 125. " +
"Use of this power without consent can lead to charges " +
"of administering a noxious substance, a crime punishable " +
"by up to one year in prison. Courts have applied this " +
"offense to Endorphin Control (Others) on the grounds " +
"that the power induces the production of a quantifiable " +
"substance within the subject's brain."
        },
        {
            id: 24,
            name: "Endorphin Control (Self)",
            category: "Presence",
            isInvestigative: false,
            position: [5, 1],
            subPosition: [4, 3],
            description: "You can stimulate your own brain to produce endorphins " +
"at will, supplying a heady rush of pleasure that blots " +
"out both physical pain and emotional trauma. To " +
"activate the power, spend X Endorphin Control (Self) " +
"points. You gain X Health points and X Composure " +
"points for five minutes, after which you lose X Health " +
"and X Composure points. You can extend this period " +
"by spending 1 Endorphin Control (Self) point for each " +
"additional three minutes."
        },
        {
            id: 25,
            name: "Entangling Hair",
            category: "Physical",
            isInvestigative: false,
            position: [1, 1],
            subPosition: [4, 2],
            description: "Your hair is long, luxurious, and prehensile. You can " +
"use it to reach out and immobilize a single foe within " +
"range. Use it in lieu of an attack, testing Entangling Hair " +
"against your opponent's Hit Threshold. If successful, " +
"you have entangled your target, who is then unable to " +
"launch attacks or take other actions. Instead, they must " +
"(assuming they don't just give in) struggle to get free from " +
"your hair's constricting grip. This requires an Athletics " +
"test, with your Entangling Hair pool as the Difficulty. " +
"When you have a target entangled, you must devote all " +
"of your attention and energy to maintaining your grip " +
"and can't take any but the most trivial of physical actions. " +
"This power's range is nonstandard, at 1m per rating point."
        },
        {
            id: 26,
            name: "Enter Dreams",
            category: "Focus",
            isInvestigative: false,
            position: [6, 0],
            subPosition: [3, 1],
            description: "By putting yourself in a trance state, you are able to " +
"enter the dreams of a sleeping person currently engaged " +
"in REM sleep. To do so, you must succeed at an Enter " +
"Dreams test, against a difficulty determined by the " +
                "distance between you and the subject." +
            "Where subjects possess any of the following mutant " +
"abilities, add their current pool in the relevant ability to " +
"your difficulty: Threat Calculus, Enter Dreams, Observe " +
"Dreams, Possession, Read Minds, or Telepathy. If they " +
"have more than one of these abilities, add the highest pool only. " +
"You may remain within the subject's dream for one " +
"minute. After that, you must spend 1 Enter Dreams point " +
"per minute to remain in the dream. Note that, contrary " +
"to popular conception, dreams do not occur in a hyper-accelerated timescale; rather, they use film-like editing " +
"techniques to jump around from one scene to the next, " +
"giving the impression of a compressed chronology. " +
"While in the dream, you may interact with the " +
"subject's dream persona. You may take control of their " +
"dream environment, shaping it to your will, introducing " +
"new characters, changing the setting, or altering the " +
"fundamentals of its illusion of reality. " +
"If the changes you make to the dream seem too strange " +
"or diverge too sharply from the subject's usual dreams, " +
"they may achieve a state of lucidity. The subject's persona " +
"realizes that they are dreaming, and gains an ability to " +
"manipulate the dream environment equal to your own. If " +
"they try to alter your dream persona, they automatically " +
"fail-and identify you as an intruder. A lucid dreamer " +
"will always remember what happened in a dream. " +
"If the changes you make to the dream render it too terrifying, the dreamer will immediately awaken, in " +
"a state of extreme agitation. They will remember the " +
"dream, but, unless they were lucid, will not automatically " +
"know you were responsible for it. (This does not prevent " +
"them from figuring it out later, especially if they are " +
"aware of you and your ability.)"
        },
        {
            id: 27,
            name: "Environmental Awareness",
            isInvestigative: true,
            position: [3, 6],
            subPosition: [3, 3],
            description: "Like an animal, your sensory apparatus constantly " +
"monitors dozens of barely perceptible cues from the " +
"natural environment. When a natural disaster such as an " +
"earthquake or tsunami is in the offing, your instinctive " +
"senses automatically detect it, long before any ordinary human. " +
"You can spot disturbances in the natural order, " +
"sense the distress of an area's wildlife population, and " +
"instinctively gauge its environmental health. With a " +
"Push, you can get stronger and more specific impressions " +
"- you can't exactly talk to animals, but you can tell the " +
"rough direction and nature of whatever disrupted the " +
"regular cycle of life. " +
"Some people with this mutation come to regard " +
"urban environments as unbearably disturbing. The " +
"overwhelming sounds and smells of mechanized life " +
"oppress them terribly, prompting them to seek out a " +
"hermit-like existence in an isolated wilderness. " +
"Environmental Awareness can substitute for Sense " +
"Trouble, provided that the hidden danger in question is " +
"somehow distressing to the local flora and fauna. " +
"Positive example: An invisible, odorless nerve agent " +
"sweeps through a forest, killing wildlife. Animals on the " +
"periphery of the gas experience distress as they horribly " +
"die. A normal player character would have to make a " +
"Sense Trouble test to notice the approaching peril; you " +
"automatically perceive the change in the environment. " +
"Negative example: A sniper draws a bead on you " +
"as you relax on the shore of an unspoiled lake. Various " +
"birds and woodland creatures are vaguely aware of him, " +
"but don't perceive him as a threat. You don't get any " +
"benefit from this mutation, but you can still make a Sense " +
"Trouble test."
        },
        {
            id: 28,
            name: "Fangs",
            category: "Physical",
            isInvestigative: false,
            position: [4, 1],
            subPosition: [2, 4],
            description: "Your upper canine teeth are two to three inches long, " +
"sharp, and hollow. They can be used as weapons in " +
"Scuffling tests, with a +0 damage modifier. You can spend " +
"points from your Fangs pool in addition to Scuffling " +
"points, but only if you're attacking with the intent to " +
"injure (in other words, you can't use Fangs if you're trying " +
"to restrain, wrestle or knock a foe unconscious). " +
"If you also have the Venom (Bite) power, you can use " +
"this bite to deliver venom. " +
"If you also have the Plasma Deficiency GRF, you " +
"can use a bite from your fangs to extract plasma from a victim. " +
"A successful fang strike counts as touching the victim, a requirement for use of the Absorption power, and using " +
"Fangs reduces the Difficulty of Absorption (p. 41). " +
"You do not need to succeed at a Scuffling test to bite a " +
"willing or possessed subject. " +
"You can spend 1 Fangs point to retract your fangs, so " +
"that they appear like normal teeth. It costs 1 Fangs point " +
"to extend them again."
        },
        {
            id: 29,
            name: "Fire Control",
            category: "Focus",
            isInvestigative: false,
            position: [4, 3],
            subPosition: [1, 4],
            description: "You can manipulate any existing flame within range, " +
"performing the following stunts. " +
"Extinguish flame (Difficulty 1 per cubic meter of " +
"flames), " +
"Cancel a Fire Projection blast before it reaches its " +
"target. The character generating the blast calculates " +
"what the damage will be if it hits; you test Fire Control " +
"against it, using the potential damage as the Difficulty. " +
"If you succeed, the blast has no effect, " +
"Increase size of flame (Difficulty 1 per cubic meter added to flames), " +
"Cause flame to leap from one fuel source to another (Difficulty 1 per m of movement), " +
"or Sculpt flame into cohesive shapes (Difficulty varies by complexity of shape, at GM's discretion, where 2 " +
"is a simple cube or pyramid, and 8 is an animated " +
"anthropomorphic figure). " +
"After animating a humanoid shape for flame, you can " +
"direct it like a puppet to fight your enemies. Use your " +
"Fire Control ability as its Scuffling; its flaming fists " +
"carry a Damage Modifier of +2. It cannot be damaged " +
"by ordinary weapons, but is destroyed on contact with " +
"flame retardant substances or by another character's " +
"opposing use of Fire Control. You must remain in direct " +
"visual contact with it, and can do nothing but direct its" +
"movements. If you are hit, entangled or forced to take " +
"other significant action, the flame loses its animation and " +
"cohesiveness."
        },
        {
            id: 30,
            name: "Fire Immunity",
            category: "Physical",
            isInvestigative: false,
            position: [4, 2],
            subPosition: [1, 4],
            description: "You can render your body impervious to fire damage. " +
"Spend 1 Fire Immunity point to reduce all damage from " +
"a single source of flame to 0. When a single source of " +
"flame would otherwise do 3 or fewer points of damage " +
"to you, it is reduced to 0 without any Fire Immunity " +
"expenditure on your part."
        },
        {
            id: 31,
            name: "Fire Projection",
            category: "Focus",
            isInvestigative: false,
            position: [4, 2],
            subPosition: [1, 3],
            description: "This blast power (see sidebar, p. 45) allows you to direct " +
"a jet of flame from your hands to a chosen target. Your " +
"hands are not damaged by your flame, but, unless you " +
"also have the Fire Immunity ability, any other part of you " +
"can be injured by your own blast. " +
"Fire Projection may also be used to ignite flammable " +
"substances. The Fire Control ability can be used to " +
"cancel your blasts."
        },
        {
            id: 32,
            name: "Flight",
            category: "Physical",
            isInvestigative: false,
            position: [2, 4],
            subPosition: [4, 4],
            description: "You can fly unaided through the air. When executing " +
"aerial stunts or maneuvers, test your Flight ability " +
"against a Difficulty determined by the GM. " +
"When your Flying pool contains 8 or more points, you " +
"fly (in combat) at 20m per round, or 10m with an action. " +
"(See p. 91 for combat movement rules.) When your pool " +
"is lower than 8, you fly at 10m per round, or 4m with an " +
"action. To quickly fly long distances, pay Flight points, as " +
"follows."
        },
        {
            id: 33,
            name: "Force Field",
            category: "Focus",
            isInvestigative: false,
            position: [6, 5],
            subPosition: [1, 4],
            description: "You can will into existence an invisible wall or bubble at " +
"any point within range. If you create a wall, the difficulty " +
"of the Force Field test to create it is 1 per square meter. " +
"The wall must conform to a straight line. The difficulty " +
"to create a bubble is 12 per meter of radius. " +
"When you first create a Force Field, multiply your " +
"pool value (after taking into account the loss of any " +
"points you spent on the original test) by 4. This is the " +
"amount of damage your force field can sustain before " +
"vanishing - any excess damage rolls over to you. Through " +
"great mental concentration, you can fortify your existing " +
"force field by spending Composure points. The damage " +
"it can sustain before collapsing increases by 2 for every " +
"Composure point spent. Once created, the force field remains stationary. " +
"Though impervious to liquids and solids, gases pass " +
"through the force field unimpeded. It cannot be used to " +
"protect you from airborne toxins, or to suffocate those " +
"trapped inside it. " +
"Force fields protect against lightning and disintegration " +
"blasts, but provide no shelter from light blasts."
        },
        {
            id: 34,
            name: "Gills",
            category: "Physical",
            isInvestigative: false,
            position: [1, 4],
            subPosition: [4, 3],
            description: "You can breathe underwater, thanks to a set of gills which " +
"open up at the sides of your neck. By spending 2 Gills " +
"points, you can cause them to seal up, so that you look " +
"normal to all but the closest medical examination. To " +
"reactivate your gills, spend another 2 points. " +
"Polluted waters may lack sufficient oxygen to breathe; " +
" make a Gills test against a Difficulty of 4 to remain " +
"normally active in any oxygen-depleted body of water."
        },
        {
            id: 35,
            name: "Gravity Control",
            category: "Focus",
            isInvestigative: false,
            position: [5, 4],
            subPosition: [4, 3],
            description: "You can increase the pull of gravity in a chosen area. " +
"The area is centered on any point within range, with " +
"a diameter of your choice, up to your current Gravity " +
"Control pool in meters. You may spend either 2 or " +
"4 Gravity Control points to activate the power. If you " +
"spend 2, the movement rates of all characters within the " +
"area are halved. If you spend 4, anyone within the area " +
"must make an Athletics test with a Difficulty equal to your " +
"Gravity Control rating to move at all. In combat, this " +
"attempt takes all of the character's energy and attention, " +
"forfeiting their chance to make an attack during the " +
"current round. The gravity field remains in force for " +
"a number of rounds equal to your rating, or until you " +
"choose to drop it. " +
"You can also decrease the pull of gravity on a " +
"particular object, causing it to rise into the air and float " +
"uncontrollably upwards like a balloon, where it remains " +
"for a number of rounds equal to your Gravity Control " +
"rating. It then drifts gently downwards for an equal " +
"number of minutes, like a depleted helium balloon, " + 
"coming to a harmless landing on the nearest horizontal " +
"surface. While suspended in the air, the object's " +
"weightless state may cause it to be buffeted by winds, so " +
"that it eventually lands far from its point of origin. Even " +
"a gentle breeze can move it a considerable distance. The " +
"cost of levitating an object varies depending on its mass. " +
"People and animals can easily (that is, without having to " +
"make a roll) slip out of the anti-gravity bubble created " +
"by this effect before they get more than a few inches off " +
"the ground. It works only on living creatures who are " +
"unwilling or unable to resist it."
        },
        {
            id: 36,
            name: "Healing",
            category: "Presence",
            isInvestigative: false,
            position: [2, 3],
            subPosition: [4, 3],
            description: "You can cure wounds and injuries (though not diseases or " +
"genetic GRFs) with a touch of your hands-skin contact " +
"required. Each Healing point spent restores one Health " +
"point to any living subject. Recipients' final Health pools " +
"may not exceed their Health ratings. " +
"By making a Healing test, you can revive the recently " +
"dead. The Difficulty depends on the time that has elapsed " +
"since the patient died." +
"No revivals are possible after six hours. " +
"You may cure your own wounds, although if you also " +
"have Regeneration, you will find that a more economical " +
"method of repairing damage to your own body. " +
"Certain toxins are cured by Healing; others, by Cure Disease."
        },
        {
            id: 37,
            name: "Hearing",
            isInvestigative: true,
            position: [2, 6],
            subPosition: [4, 1],
            description: "Your sense of hearing exceeds that of an ordinary human. " +
"You can hear sounds from a long distance. The auditory " +
"processing centers in your brain can act as on-the-fly " +
"sound editors and enhancers, cutting out background " +
"noise, zeroing in on a particular frequency, or maximizing " +
"sound from a single source (such as a pair of people " +
"conversing in the middle of a large crowd). You can even " +
"mentally replay a garbled noise, for example a misheard " +
"word or phrase, in order to make it out properly. Once " +
"you've identified a sound you can mentally compare it " +
"to another sound, to see if it derives from a similar or identical source. " +
"You can pick up most clues available to a user of " +
"the Electronic Surveillance ability, though, for obvious " +
"reasons, you are unable to create recordings for later " +
"study or use as evidence."
        },
        {
            id: 38,
            name: "Heat Blast",
            category: "Focus",
            isInvestigative: false,
            position: [2, 5],
            subPosition: [4, 1],
            description: "You can radiate a narrow blast (see sidebar, p. 45) of " +
"intense scorching heat. " +
"In addition to damaging your opponents in combat, " +
"you can use your heat blast to melt objects. The difficulty " +
"depends on the type of substance. " +
"You can melt 1kg of the substance for each minute of " +
"effort you devote to the task. To keep your heat blast " +
"going for an extended period, spend 1 Heat Blast point " +
"for each minute after the first. " +
"Heat Blast can cancel an Ice Blast before it reaches " +
"its target. The character generating the blast calculates " +
"what the damage will be if it hits; you test Heat Blast " +
"against it, using the potential damage as the Difficulty. If " +
"you succeed, the ice attack has no effect."
        },
        {
            id: 39,
            name: "High Energy Dispersal",
            category: "Presence",
            isInvestigative: false,
            position: [5, 4],
            subPosition: [1, 3],
            description: "With a quick shake of your head, you can disperse all " +
"energy generated by nearly any blast power within range. " +
"By spending 2 High Energy Dispersal points in " +
"response to the use of a blast power by a nearby mutant, " +
"you can prevent most blast powers from doing any damage " +
"to any target; human, animal, or inanimate. The beam is " +
"dispersed after it is generated but before it hits its target. " +
"Any points expended by the blast power's wielder on its " +
"damage modifier remain spent. High Energy Dispersal " +
"does not counter Concussion Beam or Ice Blast. " +
"The power has no visible effect but is accompanied " +
"by a low swishing noise, like the air being let out of a tire. " +
"You have to be in range to use this ability (see Blast " +
"Powers sidebar, p. 45)."
        },
        {
            id: 40,
            name: "Ice Blast",
            category: "Physical",
            isInvestigative: false,
            position: [1, 2],
            subPosition: [2, 4],
            description: "You can create a stream of hard ice pellets and send them " +
"hurtling at an opponent, causing damage. This is a blast " +
"power; see sidebar, p. 45. Ice Blast can be countered by Kinetic Energy " +
"Dispersal or Heat Blast. Conversely, Ice Blast can cancel a Heat Blast before " +
"it reaches its target. The character generating the Heat " +
"Blast calculates what the damage will be if it hits; you " +
"test Ice Blast against it, using the potential damage as the " +
"Difficulty. If you succeed, the heat attack has no effect. " +
"You can also use an ice blast to coat objects in ice, " +
"freeze bodies of water and so on, but remember, you're " +
"generating a hail of ice pellets, not generic \"cold\". You " +
"can't, for example, harmlessly freeze a bad guy in place, " +
"or stop a car from driving off a bridge without dealing " +
"considerable abrasive damage to the target." 
        },
        {
            id: 41,
            name: "Illusion",
            category: "Focus",
            isInvestigative: false,
            position: [5, 5],
            subPosition: [3, 4],
            description: "By overriding individuals' sensory systems, you can make " +
"them experience nonexistent objects or beings. Doing so " +
"costs 3 Illusion points for each person affected. " +
"When they interact with your illusion, your targets " +
"may make Composure tests to discern the unreality of " +
"your illusion. They continue to perceive it for its duration " +
"but know that their senses are being interfered with. " +
"Difficulties of these Composure tests depend on the " +
"illusion's complexity. " +
"Where the illusion contains multiple elements, the " +
"Difficulty is based on the element imposing the lowest " +
"challenge to the target. If you create an illusion in which " +
"the family pet (Difficulty 5) turns on a touchscreen tablet " +
"(Difficulty 8) with its nose and plays you the latest Arcade " +
"Fire tune (Difficulty 2), the final Difficulty derived from " +
"the lowest of those values, and is therefore 2. " +
"If you are within range of your target, you may " +
"continue to direct the course of a successful illusion, " +
"putting dialogue in the mouths of your imaginary " +
"characters, moving creatures about, and so on. " +
"Subjects react to horrifying illusions as if mesmerized: " +
"this power, no matter how gruesomely executed, " +
"cannot be used to induce them to flee the scene. For " +
"greater understanding of this phenomenon, consult " +
"the scientific paper \"Quasi-Hypnogogic State Variance " +
"Between Mutant Mental Abilities As Correlated To " +
"Neurotransmitter Activity,\" Dr. Aaron N. Rosenblum, " +
"Journal Of Anamorphological Neurology Studies, 12(1): 112-124. " +
"Even if the subject believes an illusion that suggests " +
"they are being harmed, they take no actual damage. " +
"A character who is already prone to cardiac arrest or " +
"severe anxiety may be required to succeed at a Health or " +
"Composure test, respectively, to stave off an attack."
        },
        {
            id: 42,
            name: "Impersonate",
            category: "Presence",
            isInvestigative: false,
            position: [5, 5],
            subPosition: [4, 1],
            description: "You can expertly mimic the vocal timbre, speech patterns, " +
"gestures, body language and gait of a chosen subject. You " +
"must first closely observe the subject, either in person or " +
"on film or video, for at least an hour. " +
"Your impostures are an incredible feat of brain " +
"processing power, and require sustained focus. After an " +
"hour, you must pay 1 Impersonate point or drop out of " +
"character. You may continue on by paying 1 point for " +
"each hour after that. Impersonate grants you no psychic knowledge of the " +
"subject. However flawless your outward mimicry, you " +
"can still be tripped up when you take an uncharacteristic " +
"action or fail to answer a question correctly. " +
"The process of mimicry does grant a limited instinctive " +
"insight into your subjects: when faced with a question you " +
"can't answer or a choice you don't know how to make, you can spend 1 Impersonate point to convincingly " +
"finesse the issue. You don't get the right answer, but do " +
"find a convincing way to put off the question. " +
"Alone, this ability requires you to use costume and " +
"makeup to disguise yourself as the subject in order to pass " +
"visual inspection. In tandem with the connected power " +
"Alter Form (p. 41), you can bodily alter yourself to match " +
"the subject, right down to fingerprints and retina pattern. " +
"(You do not, however, copy the subject's DNA or blood type.) " +
"If the subject is behaving abnormally during your " +
"observation period, you will replicate these atypical traits. " +
"For example, if you try to impersonate Johnny Depp by " +
"watching the Pirates of the Caribbean movies, you'll wind " +
"up acting like Captain Jack Sparrow, not the real person behind the performance. " +
"Especially bold impersonators have been known " +
"to, after performing extensive research, move in with " +
"their victims' families, taking over their lives like " +
"cuckoos commandeering a nest full of hatchlings. The extended absences of their subjects are often secured " +
"through murder. In at least one notorious case, the wife of a wealthy victim in such a scheme stood by the " +
"impersonator at trial, proclaiming him infinitely more loving and attentive than the original. " +
"Legal ramifications: Gaining advantage by posing as another person constitutes fraud, and may also be " +
"punishable under identity theft statutes. Law enforcement operatives using Impersonate to go undercover in " +
"the pursuit of their official duties are granted waivers shielding them from prosecution on either count. " +
"Checks to identify impersonators (typically blood tests) are part of various high-security protocols."
        },
        {
            id: 43,
            name: "Induce Aggression",
            category: "Presence",
            isInvestigative: false,
            position: [3, 0],
            subPosition: [4, 1],
            description: "You can send a psychic signal directly into a subject's " +
"limbic system, prompting them to launch an immediate " +
"attack against the person on the scene they consider to be most threatening to them. If they consider more than one " +
"person equally threatening, they attack the one closest at hand. Although the power itself grants you no influence " +
"over your victim's choice of target, you can always try to manage the situation in other ways to achieve the desired result. " +
"To use this power, make an Induce Aggression test against the standard Difficulty of 4. If successful, the " +
"subject may make a Composure test, with the result of your test as the Difficulty. If they succeed, the power " +
"has no effect. In rare cases where the victim doesn't feel remotely threatened by anyone around them, the " +
"GM may grant a bonus to their Composure test. It is frighteningly easy to use this power to turn people against " +
"their loved ones and family members. Underneath the strongest and most sincere bonds of affection lurk deeply " +
"buried fears and resentments, which this ability ruthlessly exploits. " +
"Reduce the Difficulty for targets with appropriate Stress Penalties. When you Induce Aggression, your eyes briefly but " +
"obviously glaze over, as if covered with opaque red contact lenses. The subject, if affected, then displays the " +
"same red-eyed appearance for the effect's duration. The effect lasts for 3 rounds of combat. To extend " +
"it past then, spend 1 Induce Aggression point for each additional round. " +
"Legal ramifications: Acting under the influence of Induce Aggression has been accepted as an affirmative " +
"legal defense against assault and murder charges. The vagaries of the justice system being what they are, " +
"defendants in several high-profile cases have nonetheless been convicted, despite evidence that they were targeted by it."
        },
        {
            id: 44,
            name: "Induce Fear",
            category: "Presence",
            isInvestigative: false,
            position: [3, 0],
            subPosition: [4, 2],
            description: "You can send a signal deep into a subject's limbic system, " +
"prompting them to immediately flee the scene in terror. " +
"To use this power, make an Induce Fear test. If successful, the subject may make a Composure test, with " +
"the result of your test as the Difficulty. If they succeed, the power has no effect. If they fail, they must exit the " +
"area at maximum speed using the best means at their disposal. They continue to flee for at least ten minutes. " +
"When they first begin their flight, you can increase that time by spending 1 Induce Fear point for each additional " +
"five minute interval. Even after the subject stops running, they feel a powerful aversion to the spot where you terrified them. " +
"They must make a Difficulty 4 Composure test to return there. After having done so, they still feel a nagging " +
"unease at that location, which dissipates over weeks, months, or years, depending on how often they have " +
"occasion to return to that spot. If you scare them out of their own home, for example, they readjust much more " +
"quickly than if you terrorized them from a location they rarely visit. " +
"Induce Fear mirrors the visual manifestations of Induce Aggression (above) but with bright yellow eyes."
        },
        {
            id: 45,
            name: "Induce Mental Disorder",
            category: "Presence",
            isInvestigative: false,
            position: [5, 0],
            subPosition: [4, 1],
            description: "You scramble the electrical signals in a victim's brain. You can replicate the effects of the GRFs Limbic " +
"Hypertrophy, Sensory Overload, GABA Oversufficiency, Dissociation, Low Impulse Control, Messiah Complex, " +
"Cortisol Elevation or Meta-Persona Identity Disorder. Or you can induce the following disorders. " +
"Amnesia: The subject is unable to recall details of their identity or past, though they retain a general cultural " +
"knowledge. Kleptomania: The subject is seized by a self-destructive " +
"compulsion to steal things, pursuing both the thrill of illicit thievery and the mortifying attention of being caught. " +
"Paranoia: The subject becomes convinced that they are under constant surveillance by unseen enemies who " +
"mean to destroy them, and everyone they meet may be a minion of these enemies. " +
"Pathological Liar: Driven by wounded self-esteem, the subject lies compulsively, in order to seem more " +
"impressive than they really are. Sociopathy: The subject pursues their goals without " +
"conscience, and may perform dangerous or sadistic acts for the sheer sick joy of it. " +
"A collaborative GM may allow you to propose additional disorders. " +
"To use this power, make an Induce Mental Disorder test. If successful, the subject may make a Composure " +
"test, with the result of your test as the Difficulty. If they succeed, the power has no effect. " +
"The simulated mental disorder holds sway over the victim for three hours. When you originally use " +
"the power, you can extend the duration by spending 1 Induce Mental Disorder point for each additional three " +
                "hour period. When you use this power, your eyes exhibit a gray, " +
                "swirling pattern like the eye of a hurricane. They remain " +
"this way for the effect's duration. Legal ramifications: Giving new life to the term " +
"\"temporary insanity\", courts allow defendants to claim influence of this power as an affirmative legal defense " +
"against various crimes. Juries, who typically resist even valid insanity defenses, are sometimes responsible for " +
"wrongfully convicting affected defendants."
        },
        {
            id: 46,
            name: "Invisibility",
            category: "Physical",
            isInvestigative: false,
            position: [4, 5],
            subPosition: [4, 2],
            description: "You can bend light around your body, so that you can't " +
"be seen by those whose vision is confined to the visible " +
"spectrum. Cameras and other standard imaging devices " +
"are likewise incapable of registering your presence. You " +
"can, however, be detected by thermal imagers, some " +
"animals, and mutants with the Thermal Vision power. " +
"To become invisible for ten minutes, spend 1 " +
"Invisibility point. At the end of this period, you may remain invisible for another ten minutes by spending " +
"another point, and so on. Where opponents who can't see you are concerned, " +
"your Hit Threshold increases by 1 if you are touching someone or if your last action was an attack, by 2 if you " +
"are moving but not otherwise touching or attacking, and by 3 if you are standing perfectly still. Environmental conditions, like snow or sand, that make your position " +
"clear even to those who can't see you, may fully or partially nullify Hit Threshold increases, at the GM's " +
"discretion. While invisible, you may spend Invisibility points as " +
"Infiltration or Surveillance points, gaining a +2 bonus to your roll for each Invisibility point spent. In the former " +
"instance this may enable you to surprise opponents; see \"Surprise,\" p. 94."
        },
        {
            id: 47,
            name: "Kinetic Energy Dispersal",
            category: "Presence",
            isInvestigative: false,
            position: [4, 4],
            subPosition: [2, 2],
            description: "With a wave of your hand, you can disperse all kinetic " +
                "energy invested in a single movement. This includes blunt force trauma, the force from bullets, the crushing " +
            "energy of falling debris, impact with objects moved by Telekinesis, and the blast powers Concussion Beam, Ice " +
"Blast, Spit Acid and Water Blast. By spending 2 Kinetic Energy Dispersal points, you " +
"can reduce damage from any single blow or source to any single subject within range (including yourself) to 0. This " +
"occurs after any ability points have already been spent by the party generating the kinetic energy. " +
"The power is visible as a swirling vortex that appears momentarily in the air at what would otherwise be " +
"the point of impact, accompanied by a crackling noise reminiscent of an unfolding ball of cellophane. " +
"For reasons anamorphologists have as yet been unable to explain, Kinetic Energy Dispersal does not " +
"prevent damage from bladed weapons, even though they are propelled by kinetic energy. Dr. Lucius Quade has " +
"argued that the fault lies within the mutant's imposition of a false mental framework on their own abilities, but " +
"has so far been unable to prove his hypothesis."
        },
        {
            id: 48,
            name: "Light Blast",
            category: "Focus",
            isInvestigative: false,
            position: [4, 5],
            subPosition: [2, 1],
            description: "You can project a beam of blinding white light from your " +
"hands. This is a blast power; see sidebar, p. 45. " +
"Light Blast is slightly less damaging than other blast powers; you begin with a base damage modifier of -1, " +
"instead of the usual 0. Victims of a Light Blast must make Difficulty 4 Health " +
"tests after each hit. Those who fail suffer momentary, partial blindness, causing a +3 increase to the Difficulties " +
"of any tasks requiring clear vision, as per the GM's discretion. This condition lasts until the end of the next " +
"round. Successive light blasts don't increase the penalty, but do make it last longer. " +
"Light blasts are always non-lethal."
        },
        {
            id: 49,
            name: "Light Control",
            category: "Focus",
            isInvestigative: false,
            position: [4, 5],
            subPosition: [2, 2],
            description: "You can increase or decrease the light output of any or all " +
"light sources within range. Make a Light Control test; the Difficulty equals 2, plus the number of steps of change up " +
"or down on the following list: " +
"No light emitted, " +
"Candle, " +
"Incandescent (less than 100W) or glass halogen, " +
"Incandescent (100W) or quartz halogen, " +
"Fluorescent/LED, " +
"Arc lamp, " +
"Sodium lamp, " +
"Sunlight. " +
"To plunge an area illuminated by glass halogen lights into darkness would incur a Difficulty of 4: the base of 2, plus " +
"2 for the two steps down from \"glass halogen\" to \"no light emitted.\" " +
"You can't blot out the sun, or other massive or distant light sources, but can dampen their rays within a sphere " +
"centered on any point within range. The sphere has a diameter of 1m per Light Control point in your pool."
        },
        {
            id: 50,
            name: "Lightning",
            category: "Focus",
            isInvestigative: false,
            position: [5, 4],
            subPosition: [1, 4],
            description: "This is a blast power; see sidebar, p. 45. " +
"Lightning, which follows a jagged line to find its target, is erratic and hard to dodge. When making a " +
"Lightning attack, you may choose to roll two dice and take whichever one you prefer when rolling to hit. " +
"However, if both rolls miss, then your blast hits some innocent bystander or another player character."
        },
        {
            id: 51,
            name: "Lightning Decisions",
            category: "Focus",
            isInvestigative: false,
            position: [5, 3],
            subPosition: [1, 2],
            description: "When determining whether you are an aggressor or " +
"defender in any contest, you may spend 2 Lightning Decisions points to be considered the aggressor, regardless " +
"of your pool number in the relevant ability compared to the other contestant. " +
"If the other contestant also has Lightning Decisions, the character willing and able to spend the higher number " +
"of Lightning Decisions points is declared the aggressor. If you are both willing to spend the same number " +
"of Lightning Decisions points, your pools in the ability both drop by that amount, and the normal method of " +
"determining aggressor and defender is then used. You can also spend Lightning Decisions points on the " +
"first test you make in any chase or combat. So, if the first thing you do is draw a gun and shoot, you can spend " +
"Lightning Decisions on Shooting; if the first thing you do is take cover, you can use it on Athletics."
        },
        {
            id: 52,
            name: "Limb Extension",
            category: "Physical",
            isInvestigative: false,
            position: [3, 4],
            subPosition: [3, 2],
            description: "You can extend your arms or legs far beyond their normal " +
"length. Your bones and musculature enter a semi-liquid " +
"state for the duration of the effect. Spending 1 Limb Extension point gains you up to an " +
"additional meter of length on one limb. You may extend a single limb by more than one meter, and/or extend " +
"multiple limbs at once. Extension becomes tiring after ten minutes, after which you must make a Health test " +
"(Difficulty 4) or be forced to retract the limb or limbs in question. If successful, you must test again after each ten " +
"minute interval, with the Difficulty increasing by 1 each time. Retracting costs you nothing."
        },
        {
            id: 53,
            name: "Magnetism",
            category: "Focus",
            isInvestigative: false,
            position: [5, 6],
            subPosition: [1, 3],
            description: "You manipulate magnetic waves, allowing you to perform " +
"the following stunts: " +
"\nDemagnetize: By spending 1 Magnetism point, you " +
"can create eddy currents in any single electronic device " +
"within X meters of your fingertips, where X is your " +
"current Magnetism pool before taking the required " +
"expenditure into account, disrupting it and erasing any stored information. " +
"\nMagnetize: By spending 1 Magnetism point per kg of " +
"a metal item's weight, you can charge it with magnetic " +
"energy, causing it to adhere powerfully to the nearest " +
"larger metal object. The force is sufficient to send " +
"the object hurtling dangerously through the air to its destination. " +
"\nRedirect Bullets: When another character fires a gun " +
"within your range, you may pay 2 Magnetism points to choose a new target for the bullets. " +
"The target must also be within range. Wait to announce you're using this stunt " +
"until after the shooter has fired the gun, making their " +
"test and deciding how many Shooting points to add to it. " +
"You must then make a Magnetism test, at least matching " +
"the shooter's result; otherwise, you fail to snag the bullets " +
"with your magnetic field and they continue on to their " +
"original target. If you succeed and if your Magnetism " +
"test exceeds the new target's Hit Threshold, they hit your " +
                "target. The bullets lose kinetic energy when magnetically redirected, " +
"delivering 2 damage points less than they otherwise would. If your Magnetism result is enough " +
"to snag the bullets but does not match the new target's " +
"threshold, you spoil the original attack but fail to harm " +
                "the new target. " +
"\nMutants with this power are sometimes hired as " +
"bodyguards by tabloid celebrities. They use their Magnetism to wipe memory cards used by paparazzi. " +
"This has resulted in several lawsuits."
        },
        {
            id: 54,
            name: "Memory Alteration",
            category: "Focus",
            isInvestigative: false,
            position: [5, 2],
            subPosition: [4, 3],
            description: 
            "You can send a scrambling electronic pulse into a subject's " +
"brain, interfering with their centers of memory storage. " +
"You can erase memories from a given period, possibly " +
"masking the period of amnesia with false memories of " +
"your choice. To simply erase an individual's memory of a given " +
"block of time, make a Memory Alteration test against " +
"a Difficulty determined by the interval you want to obliterate. " +
"To implant a false memory, multiply the Difficulties " +
"given above by 1.5, rounding up to the nearest whole " +
"number. The memory is only as detailed as the player's " +
"verbal description of it, so it's much easier to implant a " +
"believable memory that covers a short interval than one spanning a longer period. " +
"To use this ability, you must touch the victim's " +
"cranium with your bare hands. If they know you've done " +
"this, they'll seek out means to recover their memory (see " +
"below), so you'll either want to include the alteration " +
"in your selected interval, or ensure that they are under " +
"sedation or otherwise unable to accurately perceive your actions. " +
"When you tamper with someone's memory, you can " +
"spend any number of additional Memory Alteration points; " +
"these are added to the Difficulty of any Composure " +
"tests the victim may later make to recover their stolen recollections. " +
"The memory alteration is of indefinite duration. " +
"Whenever the subject might have reason to regain " +
"their memory, they may make a Composure test (base " +
"Difficulty 4). Reasons to make this test might include " +
"hypnotic regression therapy, or traumatic events evoking " +
"the suppressed incident. If your victim succeeds, they " +
"remember the truth, and reject their false memories. " +
"Although of little to no use in ethically performed " +
"police work, Memory Alteration is a power in great " +
"economic demand. Mutants with this power set up " +
"private practices, erasing patients' unwanted memories. " +
"They enforce corporations' draconian non- disclosure " +
"agreements, erasing the memories of top executives " +
"before they leave to join competing firms. Spy agencies " +
"are known to use memory alteration to remove classified " +
"data from the minds of agents and operatives. " +
"Legal Ramifications: Non-consensual memory " +
"alteration is a felony carrying a recommended sentence of 5-10 years per offense."
        },
        {
            id: 55,
            name: "Microvision",
            isInvestigative: true,
            position: [4, 6],
            subPosition: [2, 3],
            description: "You can selectively alter your visual perceptions to " +
"examine items at a high level of magnification, from " +
"that of an ordinary light microscope (around 1500x) to " +
"that of an electron microscope (up to 50 million times). " +
"In tandem with certain technical Investigative abilities, " +
"microvision may allow you to perform complicated lab " +
"studies instantaneously, right at the crime scene. It can " +
"be used to enhance or speed up the use of Ballistics, " +
"Chemistry, and Fingerprinting."
        },
        {
            id: 56,
            name: "Natural Weaponry",
            category: "Physical",
            isInvestigative: false,
            position: [3, 5],
            subPosition: [3, 2],
            description: "You are equipped with either claws or bony spikes. If you " +
"choose spikes, decide whether they protrude from your " +
"knuckles, ulna, elbow, or forehead. " +
"When using these weapons in Scuffling combat, your "+
"Damage Modifier is +2. " +
"You may retract or extend your natural weapon(s) by " +
"spending 2 Natural Weaponry points. " +
"You can spend Natural Weaponry points on Scuffling "+
"tests, but only if your intent is to injure."
        },
        {
            id: 57,
            name: "Night Vision",
            category: "Physical",
            isInvestigative: false,
            position: [4, 6],
            subPosition: [2, 2],
            description: "You can switch your visual senses to see plainly at night "+
"or in complete darkness. You perceive the world in the "+
"green hues of a night vision scope. Unlike technological "+
"night vision equipment, you can even see in places where "+
"no radiation is present, a fact anamorphological science "+
"has yet to convincingly explain. Spend 1 Night Vision "+
"point for every ten minute interval of active power use. "+
"At night, you can spend Night Vision points on "+
"Surveillance and Sense Trouble tests; any Night Vision "+
"spends are doubled so spending 1 point gives a + 2 bonus "+
"to your result."
        },
        {
            id: 58,
            name: "Nondescript",
            category: "Presence",
            isInvestigative: false,
            position: [6, 0],
            subPosition: [1, 4],
            description: "You blend easily into crowds and small groups, leaving "+
"little impression when you're present, and remaining "+
"profoundly unmemorable after you depart. It's not that "+
"you're invisible; instead, you seem so boring that no one "+
"thinks to engage with you. "+
"Activate this power by spending any number of "+
"Nondescript points. To notice you while present or "+
"remember you later, others must make Composure tests "+
                "(Difficulty 4 + your Nondescript expenditure.). "+
"Your preternatural dullness lasts for as long as you "+
"remain in a single location, keeping your head down and "+
"doing more or less whatever everyone else is doing. "+
"If you do something dramatic while the power is "+
"activated, people take notice, and can, if they want, take "+
"appropriate measures to stop you. However, afterwards "+
"they will remember the incident but may have trouble "+
"giving anything but the vaguest description of you. They "+
"can remember you more distinctly by making Composure "+
"tests(Difficulty 4 only)."
        },
        {
            id: 59,
            name: "Observe Dreams",
            isInvestigative: true,
            position: [6, 0],
            subPosition: [3, 4],
            description: "When within direct visual perception range of a sleeping "+
"individual undergoing REM sleep, you are able to enter a "+
"trance state, close your eyes, and see the subject's dreams. "+
"You see what the subject is dreaming from their point of "+
"view. You are unable to control the circumstances of the "+
"dream, or control the dreamer's actions within it. (The "+
"mutant General power Enter Dreams allows you to do "+
"this under certain circumstances.) "+
            "You may share the dreamer's emotions, experiencing "+
"fear, sorrow, or sexual arousal. To shut down these feelings, "+
           "make a Composure test (Difficulty 4). Emotionally raw "+
"subjects, with Composure pools of 3 or less, add 2 to your "+
"Difficulty. "+
"The dreamer remains unaware of your intrusion, "+
            "unless they become lucid during the dream. Individuals "+
"whose dreams are being observed, and who possess "+
"any of the following abilities, may become lucid on a "+
"Composure test (Difficulty 5): Empathy, Enter Dreams, "+
            "Observe Dreams, Possession, Psionic Blast, Read Minds, "+
            "and Telepathy. "+
"Upon awakening, subjects with any of these abilities "+
"may, on a Difficulty 4 Composure test, retroactively sense "+
"that their dreams were observed. "+
"Legal ramifications: Observing an individual's "+
"dreams without a legal warrant is a felony punishable by "+
"a prison term of up to five years. HCIU officers must, "+
            "working through prosecutors, demonstrate probable "+
"cause before obtaining a dream observation warrant. "+
"Witnessed dreams are admissible in court but, as "+
"unfiltered material from the subject's unconscious mind, "+
            "can be easily reinterpreted by any halfway competent "+
"defense lawyer."
        },
        {
            id: 60,
            name: "Olfactory Center",
            isInvestigative: true,
            position: [3, 6],
            subPosition: [3, 1],
            description: "You can detect and process smells to a degree far "+
"superior to a normal human. By practicing comparative "+
"smell-testing, you have become adept at identifying and "+
"distinguishing various smells. "+
"You can distinguish and recognize people by body "+
"odor. Like a sniffer dog, you can detect and identify "+
"the smells of various chemical compounds including "+
"narcotics and explosives."
        },
        {
            id: 61,
            name: "Pain Immunity",
            category: "Physical",
            isInvestigative: false,
            position: [5, 1],
            subPosition: [4, 4],
            description: "You can shut down your body's pain receptors at will. "+
"This power does not protect you from injury, just from "+
"the unpleasant sensory warnings that accompany it. "+
"You may spend 2 Pain Immunity points to remove all "+
"effects of a single source of pain. These include: "+
"�	 the need to make Composure tests to avoid taking an "+
"unwanted action motivated by pain, including giving "+
    "in to torture or ceasing an activity that's causing you "+
"injury "+
"�	 any Difficulty modifiers you incur due to distraction "+
"from pain or injury. "+
"If Hurt, you may spend 2 Pain Immunity points to ignore "+
"the penalties of that condition for the rest of the scene, "+
    "including the need to make Consciousness tests. "+
"If Seriously Wounded, you may spend 4 Pain "+
"Immunity points to ignore the penalties of that condition. "+
"If reduced to - 12 Health, you may spend 2 Pain "+
"Immunity points to keep acting for one round. You "+
"can keep doing this, but once you stop spending Pain "+
"Immunity, you perish."
        },
        {
            id: 62,
            name: "Phase",
            category: "Physical",
            isInvestigative: false,
            position: [2, 2],
            subPosition: [2, 2],
            description: "You can render yourself insubstantial, walking through "+
"walls and other solid barriers. Spend 3 Phase points "+
"to pass through any single obstruction. Barriers of 0.5 "+
"meters or more may, at the GM's discretion, cost an "+
"additional 3 points for each half a meter of thickness. "+
"You may also render yourself immune to most weapons "+
"by becoming insubstantial; this reduces the damage "+
"suffered from any attack to 0 and costs you 3 Phase points "+
"per attack. You do this after your attacker has made a "+
"successful attack test, but before they announce the result "+
"of their damage roll. (You do not lose your opportunity "+
"to phase if the GM or opposing player forgets that you "+
"have the power and goes straight to the announcement "+
"of damage.) "+
            "A suspect takes a swing at you in the interrogation "+
"room, using his Scuffling ability. He spends 2 Scuffling "+
"on the test and rolls a 2, for a test result of 4, enough to "+
"get past your Hit Threshold. \"Are you going to phase?\" "+
            "asks your GM. You decide to do so, spending 3 Phase "+
"points. The GM does not bother to roll damage, so you "+
"never know how hard a blow you just spent your points "+
"on. "+
"Phasing offers you no protection against blast powers, "+
            "except for Concussion Beam and Ice Blast. "+
"You can solidify a hand or other extremity while still "+
"inside another person(or other living organism), but "+
"as well as destroying all of your opponent's tissue with "+
"which you overlap, it destroys your extremity. You must "+
"succeed at a Scuffling test to move your fist or foot into "+
"a critical organ, like the brain, heart, or liver. You then "+
"automatically reduce the opponent to -11 or -12 Health, " +
           "depending on the location of the attack. You are reduced "+
"to -8 Health. If you recover, you lose one third of your "+
"Health rating, and no longer have the hand or foot. For "+
"obvious reasons, this is an ill- advised move in all but the "+
"most desperate circumstances. Having Regeneration "+
"is no help here, as the lack of an extremity to reattach "+
"prevents you from fully restoring yourself. "+
"You can phase up to about a kilogram of clothing "+
"and small personal effects with you. You cannot solidify "+
"clothing or other objects while inside another person(or "+
"living organism). "+
"Legal Ramifications: Phase is an Article 18 power; "+
    "see p. 123."
        },
        {
            id: 63,
            name: "Plant Communication",
            isInvestigative: true,
            position: [5, 0],
            subPosition: [1, 4],
            description: "You can attune yourself to the electromagnetic, non- "+
"sentient consciousness of plants, gleaning information on "+
"the following and similar subjects. "+
"�	 Has the area been disturbed recently ? "+
"�	 Have any traumatic events happened here lately ? "+
"�	 Have there been any storms lately ? "+
"�	 Is a storm coming ? "+
"�	 Is the soil moist ? "+
"�	 Is the soil well fertilized ? "+
"�	 What is eating the plants here, and to what extent ? "+
"�	 For flowering or fruiting plants, when was the last "+
"time you were harvested ? "+
    "You are not literally talking to the plants, but sensing the "+
"answers based on their general health and the state of "+
"their electromagnetic auras."
        },
        {
            id: 64,
            name: "Plant Control",
            category: "Presence",
            isInvestigative: false,
            position: [5, 0],
            subPosition: [1, 3],
            description: "You can invest all plants within a discrete area with rapid "+
"growth and mobility, allowing them to immobilize one "+
"or more targets. Choose any point within range as the "+
"center of the effect; it works on all vegetation within a "+
"circular area with a diameter of 1m per point in your "+
"Plant Control pool(before any points are spent to increase "+
"your test result or the number of targets). Designate "+
"the number of targets you want to restrain, paying an "+
"additional 1 Plant Control point for each after the first. "+
"If your result equals or exceeds a target's Hit "+
"Threshold, they are immobilized. Assuming they resist, "+
            "they must spend their next action attempting to get free "+
"from the entangling vegetation. This requires a test of "+
"Athletics, Strength, or any blast power against a Difficulty "+
"of 4. Each additional Plant Control point you spend adds "+
"1 to the difficulty for all entangled opponents. "+
                "Obviously, this power is useless in areas without "+
"significant plant life, like many streets in highly urbanized "+
"areas."
        },
        {
            id: 65,
            name: "Possession",
            category: "Presence",
            isInvestigative: false,
            position: [4, 1],
            subPosition: [2, 2],
            description: "You can override the consciousness of a chosen victim, "+
"controlling their motor impulses and impelling them "+
"to perform one or more actions. The subject must be "+
"within 1m of you, and you must be able to make direct "+
"eye contact with them. Make a Possession test(Difficulty "+
"4). The victim must be able to see your eyes, it doesn't "+
"matter if you can see theirs. Mirrorshades and similar "+
"devices offer no protection against possession. However, "+
            "during fights, chases and other fast- moving situations "+
"where eye contact is tough to establish, the Difficulty of "+
"your Possession test may increase from + 1 to + 4, at the "+
"GM's discretion. "+
"On a success, the subject must make a Composure test "+
"with your Possession result as the Difficulty. If they fail, "+
    "you override their volition. Their eyes become glassy; if "+
"you impel them to speak, their voice is slow and slurred. "+
"Any observer can spot these obvious symptoms of a "+
"possession in progress. It takes an expert in the EMAT "+
"protocol to spot the signs of recent, but no longer active, "+
    "possession. "+
"At no further cost, you can command the subject "+
"to perform one action. Each action after that costs you "+
"an additional 4 Possession points. You may not access "+
"any Investigative abilities possessed by the subject, or "+
"the following powers or General abilities: Cognition, "+
    "Empathy, Enter Dreams, Illusion, Impersonate, "+
    "Mechanics, Medic, Observe Dreams, Precision Memory, "+
    "Read Minds, Surveillance, or Threat Calculus. Other "+
"abilities may be used but suffer a + 2 Difficulty modifier. "+
    "The victim's personality is completely suppressed, so "+
"you can command their body to do whatever you want, "+
    "regardless of their conscience or moral code. "+
"If the victim's failed Composure test came within "+
"2 points of the needed Difficulty, they remain aware "+
"but helpless as you control them. Otherwise, they are "+
"unaware of what they are doing, and retain no memory "+
"of it thereafter. "+
"Possession continues indefinitely, until you perform "+
"any other action requiring you to use an Investigative "+
"ability, or make a General ability test. "+
"When you first establish the possession, and each time "+
"you force the victim to take action, your eyes glow bright "+
"green. This effect can easily be seen by nearby witnesses "+
"and captured on still or video camera. "+
"Legal ramifications: Use of the Possession power, "+
    "which is nonconsensual essentially by definition, is a "+
"felony punishable by up to 10 years in prison. Claims "+
"of possession have been accepted as an affirmative legal "+
"defense against various criminal charges. Juries, however, "+
    "remain skeptical where solid evidence of possession "+
"cannot be shown by defense counsel."
        },
        {
            id: 66,
            name: "Precision Memory",
            category: "Focus",
            isInvestigative: false,
            position: [5, 3],
            subPosition: [4, 1],
            description: "You display astonishing recall of events and visual details. "+
"You can recite the contents of a thousand- word document "+
"verbatim after glancing at it for a few seconds. "+
"Whenever you, the player, make a statement based on "+
"a faulty recollection of prior events in the game, the GM "+
"immediately steps in to correct you. This is a mistake, "+
    "you, the character, would never make. Each correction "+
"costs you 1 Precision Memory point. If your pool is at 0, "+
    "the GM allows your faulty memory to stand. "+
"You may retrospectively gain clues that were available "+
"to you in prior scenes, by thinking back on the scene. This "+
"costs you 1 Precision Memory point per scene, whether "+
"or not you recover useful clues. These must be clues that "+
"could logically be pieced together without returning to "+
"the scene or conducting further physical interactions "+
"with it. You can't know what was in a box if you didn't "+
"open it. However, remembering its outer markings in "+
"detail, you can retrospectively employ your Art History "+
"ability, identifying it as a 16th century piece in the style "+
"of Benvenuto Cellini. Given the above limitation, you "+
"can even use Pushes retroactively."
        },
        {
            id: 67,
            name: "Psionic Blast",
            category: "Focus",
            isInvestigative: false,
            position: [4, 3],
            subPosition: [4, 1],
            description: "You emit a wave of electrical energy which interferes "+
"with a living being's brainwaves, causing mental trauma "+
"and, in some cases, brain damage. This is a blast power; "+
            "see sidebar, p. 45. "+
"Psionic Blast differs from other blast powers in that "+
"it reduces the victim's Composure instead of Health. "+
               "However, the damage suffered is a physical blunt force "+
"injury to the brain, rather than emotional trauma. If a "+
"Psionic Blast drives a character's Composure pool to 0, "+
            "further damage from the blast affects Health instead. "+
"Damage from Psionic Blast can be healed by the "+
"Empathy ability. Unaided, the victim heals naturally at a "+
"rate of 2 Composure points per day."
        },
        {
            id: 68,
            name: "Quills",
            category: "Physical",
            isInvestigative: false,
            position: [1, 1],
            subPosition: [4, 4],
            description: "Your back, shoulders and forearms are covered with "+
"dozens of long, spiny quills, like those of a porcupine. "+
"Your damage modifier when Scuffling unarmed is + 1. "+
"Whenever an opponent who is Scuffling with you gets a "+
"Scuffling test result exactly equal to your Hit Threshold, "+
    "that opponent suffers a die of damage, plus your + 1 "+
"modifier. "+
"You may spend 2 Quills points to retract or extend "+
"your quills. You can spend Quills points on Scuffling tests."
        },
        {
            id: 69,
            name: "Radiation Immunity",
            category: "Physical",
            isInvestigative: false,
            position: [3, 3],
            subPosition: [2, 4],
            description: "Whenever you suffer damage from Radiation Projection, "+
"or any other radiation source, you may pay 1 Radiation "+
"Immunity point to reduce the damage to 0. "+
"If you also possess the Radiation Projection power, "+
           "you are automatically immune to the damage inflicted "+
"by your own power, and needn't pay points to reduce it "+
"to 0. You must still pay when targeted by other mutants' "+
            "Radiation Projection."
        },
        {
            id: 70,
            name: "Radiation Projection",
            category: "Physical",
            isInvestigative: false,
            position: [3, 3],
            subPosition: [2, 3],
            description: "You can bombard targets with highly concentrated "+
"radiation. This is a blast power; see sidebar, p. 45. "+
"Whenever you use your power, everyone within "+
"X meters of you(where X is your current Radiation "+
"Projection pool) must make a Health test or lose 1 point "+
"of Health to radiation damage. This includes you, unless "+
"you also possess the power Radiation Immunity. "+
"At the end of any scene or combat in which you "+
"used your power, everyone who took damage from you "+
"must make a Health test against a Difficulty equal to "+
"the number of Health points you cost them. Again, this "+
"includes you, unless you also have Radiation Immunity. "+
"Characters who fail contract radiation sickness. Every "+
"24 hours, they suffer an amount of damage that doubles "+
"each day: 1 Health points the first day, 2 the second, 4 "+
"on the third, 8 on the fourth, and so on. The doubling "+
"continues until the character is healed(only the Cure "+
"Disease power will do the trick) or reaches -12 Health "+
"points and dies. "+
"Legal Ramifications: Radiation Projection is "+
"considered an Article 18 power(see p. 123); mutants "+
"possessing it face severe legal restrictions. If your "+
"character has this dangerous and much- feared power, "+
        "you'll have to explain to the GM's satisfaction how you "+
"ever got hired on to the HCIU. If you are ever caught "+
"using it, on duty or off, it will probably spell the end of "+
"your career, requiring you to retire the character."
        },
        {
            id: 71,
            name: "Read Minds",
            isInvestigative: true,
            position: [5, 2],
            subPosition: [1, 3],
            description: "You can read the surface thoughts of any individual "+
"within your direct, unaided line of sight. Subjects' sub- "+
"vocal thoughts register in your central auditory system, "+
            "as if they are whispering in your ear. At your default level "+
"of concentration, you can't direct subjects' thoughts, but "+
"merely eavesdrop on what they are already thinking. "+
                "Sub - vocal thoughts tend to be much more fragmentary "+
"and loopingly repetitive than spoken speech. "+
"Subjects with the abilities Empathy, Read Minds and "+
"Telepathy automatically detect your attempt to read their "+
"thoughts. They can block it by spending a Push. You may "+
"overcome their defenses if you're willing to spend more "+
"Pushes than they are. "+
"If you spend a Push, you can drill down into a subject's "+
"memory, finding the answer to a single question. This "+
"process is noticeably invasive, even to victims without the "+
"above- named powers. They must make Composure tests "+
            "(Difficulty 4) to resist feelings of terror, violation or intense "+
"paranoia. Whether or not they suffer such sensations, "+
        "subjects experience hangover - like symptoms which persist "+
"for about forty- eight hours. Also, they become obsessed "+
"with matters related to your question for a period of a "+
"week or so. Victims without the above - mentioned powers "+
"probably know they've been psychically assaulted but, "+
    "without additional information, can't identify you as the "+
"perp. With those powers, they are able to identify you. "+
"Information gleaned by mind reading is accurate "+
"but subjective. If the subject is self - deceptive, delusional "+
"or simply misinformed, the facts you extract will be "+
"incorrect. Bullshit Detector can't help you sort out true "+
"from false belief. "+
"Legal ramifications: Mind reading without either "+
"the subject's consent or a legal warrant is a felony "+
"punishable by up to twenty years in prison. HCIU "+
"officers must work with prosecutors to secure warrants, "+
    "supplying a judge with probable cause. Information "+
"gained from mind reading is thus more likely to be used "+
"to develop a case, or to gather intelligence on an exigent "+
"basis, than as trial evidence. "+
"In addition to the above rest"
        },
        {
            id: 72,
            name: "Reduce Temperature",
            category: "Presence",
            isInvestigative: false,
            position: [1, 2],
            subPosition: [2, 3],
            description: "You can reduce temperatures in a spherical area centered "+
"on any point within range. The diameter of the sphere "+
"is 1m for each point in your Reduce Temperature pool. "+
"To activate the power, make a Reduce Temperature test. "+
"The Difficulty equals 3, plus 1 for every 5�C you want "+
"the temperature to drop."
        },
        {
            id: 73,
            name: "Reflexes",
            category: "Focus",
            isInvestigative: false,
            position: [5, 4],
            subPosition: [1, 2],
            description: "You react to incoming threats with preternatural speed. "+
"You may spend 2 Reflexes points to automatically "+
"succeed at any dodge attempt that would normally "+
"require an Athletics test. "+
"To avoid a successful Shooting or Scuffling attempt, "+
            "make a successful Reflexes roll, with the result of the "+
"Shooting or Scuffling attempt as your Difficulty. You can "+
"only dodge attacks that you're aware of; you can't dodge "+
"a sucker punch or sniper shot."
        },
        {
            id: 74,
            name: "Regeneration",
            category: "Physical",
            isInvestigative: false,
            position: [2, 4],
            subPosition: [4, 1],
            description: "Your body naturally heals itself of even the most "+
"gruesome injuries. Once every three minutes, you may "+
"spend 1 Regeneration point to refresh 2 lost or spent "+
"Health points. This requires no concentration on your "+
"part; you can carry on doing whatever you're doing as "+
"lacerated muscle knits together, bones fuse and snap into "+
"place, and sliced skin smoothes itself over. "+
"If your Regeneration rating is 8 or more, the power "+
"can bring you back from the dead. Provided that your "+
"Health pool is no lower than -18, you can continue to "+
"spend Regeneration points(once every three minutes, as "+
"usual) until you reach -11 and come sputtering back to "+
                "(seriously wounded) life. "+
"You can't regrow a limb or other lost or severed body "+
"part in its entirety, but if you still have the missing bit you "+
"can stick it back onto or into its correct anatomical location "+
"and watch in nauseated wonder as your regeneration "+
"power knits the severed tissue back together. Your once- "+
"severed organ or extremity is considered reattached "+
"when you cross the boundary from seriously wounded to "+
"hurt. If you are already hurt or healthy, it fully reattaches "+
"upon your first expenditure of Regeneration points."
        },
        {
            id: 75,
            name: "Resist Influence",
            category: "Presence",
            isInvestigative: false,
            position: [3, 0],
            subPosition: [1, 4],
            description: "When you make a Composure test to avoid the effect of "+
"a mutant power, the Difficulty of that test is reduced by "+
"2. You may reduce the Difficulty by an additional 1 for "+
"every Resist Influence point you spend."
        },
        {
            id: 76,
            name: "Secrete Acid",
            category: "Physical",
            isInvestigative: false,
            position: [3, 1],
            subPosition: [1, 4],
            description: "The pores of your palms secrete a powerful acid, which "+
"can be used to destroy small objects, or at least render "+
"them unusable. To destroy or degrade an object, make a "+
"Secrete Acid test, with the Difficulty determined by the "+
"GM, using the following examples as a guideline. "+
"If you touch someone's bare skin while secreting acid, "+
            "they lose 1 Health point. If you strike them in a Scuffling "+
"contest, you add 1 to your damage bonus for every 2 "+
"Secrete Acid points you spend. You can spend no more "+
"than 20 Secrete Acid points on a single attack."
        },
        {
            id: 77,
            name: "Self-Detonation",
            category: "Physical",
            isInvestigative: false,
            position: [3, 2],
            subPosition: [2, 4],
            description: "You blow up real good. By initiating a chemical reaction "+
"in your entire body, you can cause a spontaneous "+
"detonation. To activate the power, first decide which "+
"class of explosive device you wish to emulate(see p. 99 "+
"for more about explosives). This determines the eventual "+
"Difficulty of your Self- Detonation test: "+
        "It takes you a number of rounds to activate the power "+
"equal to the specified explosive class. You must stand "+
"still and concentrate throughout this period. Your body "+
"trembles and is surrounded by a nimbus of crackling "+
"energy, making what you are doing obvious to any "+
"trained eye. All HCIU officers have been trained to "+
"recognize these signs. "+
"If you lose consciousness or take any other action "+
"during the activation period, you lose a number of Self-"+
"Detonation points equal to the Difficulty of the attempt, "+
        "and the effect does not occur. "+
"At the end of the activation, make your test. On a "+
"success, the specified explosion occurs, with your position "+
"as its center. Your body literally flies apart with deadly "+
"force. "+
"Your constituent atoms float about in the atmosphere "+
"for a period called the Reconstitution Interval (see table, "+
    "above). When it elapses, you reform, unharmed, with "+
"all of your pools refreshed. Your reappearance occurs at "+
"a location of your choice within a distance of the blast "+
"location equal to your Self-Detonation rating times 250 "+
"meters. "+
"If you also possess the power Radiation Projection, "+
    "you can choose to activate it as you explode, heavily "+
"irradiating the area of the explosion, and, in the case of "+
"an open-air explosion, polluting the air with radioactive "+
"fallout. "+
"You are unable to produce explosions less effective "+
"than a pipe bomb."
        },
        {
            id: 78,
            name: "Sexual Chemistry",
            category: "Presence",
            isInvestigative: false,
            position: [6, 1],
            subPosition: [3, 2],
            description: "You may, at will, emit powerful pheromones provoking "+
"in others an intense desire to have sex with you. "+
"The ability is not selective: a pheromone emission "+
"will affect everyone within approximately 30m. Judicious "+
"mutants use it only when they are alone with their chosen "+
"targets. "+
"Affected individuals must make a Composure test to "+
"avoid influence. You may spend any number of Sexual "+
"Chemistry points, adding to the test's base Difficulty "+
"of 4. All targets are affected by this expenditure. The "+
"Difficulty of the test decreases by 8 for targets whose "+
"sexual orientation would normally rule you out as a sex "+
"partner. "+
"Those who succumb to your chemical charms will "+
"behave toward you as they would toward anyone to whom "+
"they feel an overwhelming physical attraction. People on "+
"the sexual prowl will come on to you. Those who react "+
"to sexy people by becoming shy and withdrawn become "+
"helplessly introverted. Individuals deeply committed "+
"to celibacy or monogamous relationships will fight to "+
"control their sudden urges. "+
"In all instances, however, subjects will feel a reflexive "+
"urge to cater to you and make you happy. This impulse "+
"is limited by the individual's typical code of behavior. An "+
"already-shady character might commit crimes for you. "+
"An upright citizen will refuse, but will feel sufficiently "+
"drawn to you that they won't inform the authorities. "+
"You get a free Push that can be spent on any suitable "+
"Interpersonal Ability when dealing with the subject "+
        "(usually Charm). "+
"When a PC is affected by the power, the player decides "+
"to what extent the character's reaction exceeds a general "+
"desire to please the wielder. "+
"Legal ramifications: Use of this power is not illegal "+
"but has on occasion led victims to sue those who wield it "+
"in civil court for causing undue emotional distress, with "+
"mixed success. "+
"Users of this ability have occasionally been charged "+
"with riot incitement. Deploying it in a crowded place can "+
"be extremely dangerous to the user. Rapists have been "+
"exonerated or given reduced sentences by arguing that "+
"they were acting under the influence of this power."
        },
        {
            id: 79,
            name: "Sonar",
            category: "Physical",
            isInvestigative: false,
            position: [2, 5],
            subPosition: [4, 3],
            description: "By emitting a series of high frequency sounds and waiting "+
"to hear them echo back to you as they bounce off various "+
"surfaces, you can sense your relationship to other people "+
"and objects in three-dimensional space. You are mostly "+
"unaffected by darkness, smoke and other conditions that "+
"might interfere with vision. "+
"Your sonar sense extends from you in all directions, "+
    "to a maximum distance of 10m per point in your Sonar "+
"pool. "+
"Sonar provides more reliable depth perception "+
"information than the sense of sight. You may grant "+
"yourself a single +2 modifier on any Shooting test by "+
"spending 1 Sonar point. "+
"This sense allows you to detect mutants using "+
"the Invisibility power. You automatically succeed in "+
    "disbelieving any illusion with a strong visual component, "+
        "because your echolocation registers elements of the "+
"illusion as lacking physical substance. "+
"If you also have the Gills mutation, you can use Sonar "+
"underwater, overcoming problems of visibility even in "+
    "the deepest and darkest waters."
        },
        {
            id: 80,
            name: "Sonic Blast",
            category: "Physical",
            isInvestigative: false,
            position: [2, 5],
            subPosition: [4, 2],
            description: "This blast power (see sidebar, p. 45) allows you to emit a "+
"high-frequency screech, which forms in your diaphragm "+
"and emanates from your mouth. High frequency sound "+
"waves buffet your intended target, damaging their soft "+
"tissue and internal organs. "+
"Sonic blasts cause collateral damage. If you succeed "+
        "in damaging your opponent, anyone standing within "+
"X meters of your target, where X is your current pool "+
        "in Sonic Blast after any spent on the attack, also loses 1 "+
"Health point. You are immune to your own sonic blast, "+
        "but not to those of other mutants."
        },
        {
            id: 81,
            name: "Spatial Awareness",
            isInvestigative: true,
            position: [5, 6],
            subPosition: [1, 1],
            description: "Your brain manifests a superhuman command of three-" +
"dimensional information. You can perfectly measure "+
"distances by sight. You can calculate a complex set of "+
"bullet trajectories in your head, instantly garnering results "+
"that what would take a mundane crime scene technician, "+
            "working with a complicated set-up of threads or lasers, "+
       "hours to complete. You can intuit the precise movements "+
"and actions undertaken at a crime scene merely by "+
"comparing the relationships between disturbed objects "+
"and such other indicators of movement as blood spatters "+
"and footprints. "+
"This ability can also improve your Shooting. Push "+
"Spatial Awareness to increase your Damage Modifier "+
"with missile weapons by 1 for the duration of a single "+
"combat. You may not increase your modifier by more "+
"than 1, or increase the damage modifier of a blast power."
        },
        {
            id: 82,
            name: "Speed",
            category: "Physical",
            isInvestigative: false,
            position: [5, 4],
            subPosition: [1, 1],
            description: "You can run at a highly accelerated speed. "+
"So long as you have 1 or more points in your Speed "+
"pool, you can move at the following rates during combat. "+
"You can travel 20m (or ten grid squares, if you're "+
"using-see \"Distance,\" p. 91), if all you're doing is "+
"moving. Or you can take significant action and also move "+
"10m (or 5 grid squares). This movement can take place "+
"before or after your action, or you can break it up, in 2m "+
"increments, bookending your action as desired. You can "+
"therefore move 2m, take an action, then move another "+
"8m, or move 6m and then 4m, and so on. "+
"Under difficult terrain or environmental conditions, "+
    "like uneven ground or storms, your maximum speed "+
"is 10m / 5 grid squares (without an action) or 4m / 2 grid "+
"squares with an action. "+
"To run at high rates of speed over long distances, pay "+
"the following number of Speed points for each km, or "+
                "fraction of a km, you run at the following speeds. " +
                "Additionally, you can dodge gunfire and other Shooting "+
"attacks by making Speed tests. Use the value of the attack "+
"roll as the Difficulty. "
        },
        {
            id: 83,
            name: "Spit Acid",
            category: "Physical",
            isInvestigative: false,
            position: [3, 1],
            subPosition: [1, 3],
            description: "You can spit globules of highly concentrated acid at your "+
"enemies, damaging them from a distance. This counts as "+
"a blast (p. 45), and can be countered by Kinetic Energy "+
"Dispersal (p. 56), which causes your globule to dissipate "+
"harmlessly. "+
"Spit Acid deals -2 damage, but keeps damaging "+
"the target in every subsequent round until the acid's "+
"removed. Keep the original result but reduce the damage "+
"inflicted by the acid by 1 each round. So, if you hit a foe "+
"for 4 damage this round, they'll take 3 points of damage "+
"next round, 2 points in the following round, and 1 point "+
        "in the round after that. The target may stop this ongoing "+
"damage if they somehow wash away the acid in time. "+
"The acid produced by this power is chemically distinct "+
"from that of the Secrete Acid power, and is incapable of "+
"doing significant damage to inorganic matter."
        },
        {
            id: 84,
            name: "Spontaneous Combustion",
            category: "Presence",
            isInvestigative: false,
            position: [4, 3],
            subPosition: [1, 1],
            description: "You can initiate a process of rapid oxidization, causing "+
"objects within standard range to burst into flames. "+
"Test Spontaneous Combustion against a Difficulty "+
"determined by the type of material. GMs should "+
"extrapolate Difficulties for unlisted materials based on "+
"the entries below. "+
"This assumes you're igniting about 1kg of material. "+
"Double the Difficulty for each additional kg of material "+
"initially ignited. In the case of a material with a base "+
"Difficulty of 4 or less, fire will quickly spread to the rest "+
"of the object. Less flammable materials will tend to burn "+
"out when the area you have ignited is consumed. "+
"Damage done to living tissue causes a loss of 1 Health "+
"point per 1 kg ignited per round while on fire, to a "+
"maximum of 3 lost Health points. "+
"The flame you generate can be extinguished by any "+
"normal means - and by Fire Control, of course."
        },
        {
            id: 85,
            name: "Spread Pathogen",
            category: "Presence",
            isInvestigative: false,
            position: [5, 1],
            subPosition: [1, 1],
            description: "By triggering genetic changes in the benign bacteria "+
"inhabiting a subject's body, you can infect them with a "+
"debilitating, contagious flu-like disease. Make a Spread "+
"Pathogen test against a target within a number of meters "+
"equal to your Spread Pathogen pool. The subject makes "+
"a Health test; if your Spread Pathogen test exceeds both 4 "+
"and the Health result, the pathogen takes effect. "+
"The subject loses a number of Health points equal "+
"to the difference between your two results. They sicken "+
"rapidly and, after ten minutes, begin to suffer from a "+
"constellation of symptoms including coughing, sneezing, "+
    "sinus pressure, headache, chills, and physical weakness. "+
"Subjects are unable to think properly, losing the ability "+
"to use Investigative abilities, and suffer a +3 increase to "+
"all General ability Difficulties. To undertake any action "+
"that would delay them from heading home and crawling "+
"into bed, they must make Composure tests (Difficulty 4). "+
"At the moment the subject gets sick, spend any "+
"number of Spread Pathogen points; this expenditure "+
"determines the virulence of the pathogen. If you spend "+
"no points, it is not contagious. Anyone coming within 1m "+
"of the subject while they remain sick must make a Health "+
"test against the number you have set as the virulence. If "+
"they fail, they suffer the same ill effects as the original "+
"victim. Unlike your primary target, their version of the "+
"pathogen is not contagious. "+
"Sufferers of the infection may make a Health test "+
"at the end of each twenty-four hour period to recover "+
"from it. The Difficulty starts at three times the virulence "+
"and drops by 2 every day. Cure Disease can remove the "+
"Pathogen (Difficulty = Virulence x 3) and allows the "+
"victim to heal normally."
        },
        {
            id: 86,
            name: "Strength",
            category: "Physical",
            isInvestigative: false,
            position: [2, 4],
            subPosition: [4, 2],
            description: "The SME hardened your muscle fibers to the toughness "+
"of steel, allowing you to perform incredible feats of "+
"strength. "+
"Your Damage Modifier when fighting unarmed is +1 "+
"for every 4 points in your Strength pool, to a maximum "+
"of +4. "+
"You can spend Strength points in Athletics tests in " +
    "which muscle power is a factor, including lifting, running, "+
        "and breaking down doors, gaining 3 Athletics points for "+
"every Strength point spent. "+
"When the feat you wish to attempt surpasses the limits "+
"of ordinary human ability, you instead make a Strength "+
"test, with a Difficulty chosen by the GM, using the "+
"following guidelines as a benchmark."
        },
        {
            id: 87,
            name: "Suppress Explosion",
            category: "Physical",
            isInvestigative: false,
            position: [3, 2],
            subPosition: [2, 2],
            description: "You can alter the kinetic energy fueling an explosion, "+
"dissipating its force and converting it into a harmless "+
"implosion. "+
"As an explosion first occurs, make a Suppress "+
"Explosion check, with a Difficulty equal to twice the "+
"device's Explosive Device Class(see p. 99). If successful, "+
            "the bomb fizzles and has no effect. If you fail, it does its "+
"normal damage. "+
"If preventing a mutant with the Self-Detonation "+
"power from exploding, make a Suppress Explosion test "+
"with the result of your opponent's Self-Detonation test as "+
"your Difficulty. "+
"HCIU members with this mutation probably served "+
"on the bomb squad before earning a transfer to their "+
"present assignment. If so, remember to buy yourself the "+
"Investigative ability Explosive Devices."
        },
        {
            id: 88,
            name: "Suppress Influence",
            category: "Presence",
            isInvestigative: false,
            position: [6, 2],
            subPosition: [3, 4],
            description: "You can block mind-controlling mutants from exercising "+
"their influence in a particular area. Specify an area of up "+
"to 3 cubic meters. No individual within that area, other "+
"than yourself, can be targeted by mutant powers resisted "+
"by a Composure test. The protection remains active for "+
"ten minutes for each Suppress Influence point you spend. "+
"You may expand the area by 3 cubic meters for each "+
"additional Suppress Influence point you spend."
        },
        {
            id: 89,
            name: "Swimming",
            category: "Physical",
            isInvestigative: false,
            position: [1, 4],
            subPosition: [4, 4],
            description: "You can swim at a high rate of speed, executing complex "+
"maneuvers in the water. Your movement rate while "+
"swimming equals your running speed on land. While "+
"swimming, most physical feats you undertake use "+
"Swimming tests, instead of Athletics."
        },
        {
            id: 90,
            name: "Technokinesis",
            category: "Focus",
            isInvestigative: false,
            position: [5, 4],
            subPosition: [4, 1],
            description: "You can impel machines and devices to do your bidding. "+
"You must be touching the machine to activate the power; "+
            "afterwards, it costs 1 point per combat round to maintain "+
"a connection to the machine, even if you're not actively "+
"controlling it. "+
"To activate the power, make a Technokinesis test "+
"against a Difficulty determined by the complexity "+
"of the machine(see table). Only devices including "+
"electrical components are subject to your whims; purely "+
"mechanical devices like pendulums, levers and pulleys, or "+
"even low- tech guns, are beyond your control. Generally, "+
        "the machines appear to be operating themselves. When "+
"you cause a car to drive, for example, its steering wheel "+
"and pedals move as if controlled by an invisible entity. "+
"You can operate a computer or other similar device "+
"using this power, and do so at the machine's maximum "+
"input speed. For example, you could \"type\" a lengthy "+
"essay as quickly as you can think the words, or use a "+
"digital painting program to create images you visualise in "+
"your mind's eye. You cannot, however, do anything you "+
"couldn't do using the normal user interface. "+
"GMs use the following table as a guide to machine "+
"complexity. "+
"Although you can override a machine's controls, locks "+
"and safety mechanisms, you can't cause it to do anything "+
"beyond the limits of its design. You can command a "+
"vending machine to spit out its coins or release all of "+
"its cans of soda, but you can't get it to fire missiles at "+
"incoming attackers or trundle down a corridor to block a "+
"door for you, because it is not designed to perform these "+
"tasks."
        },
        {
            id: 91,
            name: "Technopathy",
            isInvestigative: true,
            position: [5, 3],
            subPosition: [4, 3],
            description: "Technopathy allows you to extract information from any "+
"machine that stores digital data, such as a computer hard "+
"drive. It functions as a more impressive, more covert form "+
"of Data Retrieval. You must touch the item where the "+
"data is stored; contact with a computer monitor in one "+
"room does not permit you to access information from a "+
"server in another part of a building. You can access a wifi network simply by touching the copper contact points "+
"of a laptop wireless card to your tongue, but again, you "+
"can't get access to stored data unless it's in transit across "+
"the network. "+
"You can access information on a cellphone, but can't "+
"pull data off the phone network or the cloud without "+
"access to phone company servers. "+
"You can bypass security restrictions like passwords, "+
            "but certain forms of encryption baffle you without the "+
"use of Cryptography. You can parse simple forms of "+
"data, but more complex structures may be beyond your "+
"ability to visualize. For example, you could easily \"read\" "+
            "a text document or \"see\" an image file, but unless you've "+
"got Architecture, you might not be able to understand "+
"that this highly complex 3d model is an architect's "+
"plans for a bank vault, while you might need Forensic "+
"Anthropology to recognize a set of DNA records. "+
"This power does not allow you to write or transfer "+
"data from one system to another. "+
"Legal Ramifications: In many instances, "+
            "Technopathy allows you to gather electronic information "+
"covertly and non-invasively. However, evidence gathered "+
"this way is not admissible in court. Technopathy is an "+
"Article 18 ability."
        },
        {
            id: 92,
            name: "Telekinesis",
            category: "Focus",
            isInvestigative: false,
            position: [5, 6],
            subPosition: [3, 1],
            description: "You can move objects by sheer force of will. The base "+
"Difficulty of the Telekinesis test to move an object is 0, "+
            "modified by factors including its size, the distance you "+
"want it to travel, and its speed. "+
"Objects moved nearly instantaneously can, if your "+
"Telekinesis test result exceeds a target's Hit Threshold, "+
            "do damage, like a missile weapon. The Damage Modifier "+
"from such attacks is determined by the mass of the item. "+
"Kinetic Energy Dispersal can be used to counter these "+
"telekinetic attacks."
        },
        {
            id: 93,
            name: "Telepathy",
            category: "Focus",
            isInvestigative: false,
            position: [6, 3],
            subPosition: [3, 2],
            description: "You can silently project your thoughts into the minds "+
"of others. Recipients hear your thoughts spoken in your "+
"voice, as if through earphones. You can establish the "+
"link so that it is one way only, or so that you can hear "+
"their thoughts as well. Participants in the telepathic link "+
"communicate only the thoughts they wish to. You can't "+
"use Telepathy to read minds; nor do your subjects gain "+
"unauthorized access to your thoughts. "+
"You can open a psychic channel to a single individual "+
"by paying 2 Telepathy points. You may maintain "+
"multiple links at once. To open several active links so that "+
"participants can communicate with each other as well, "+
            "pay an additional 2 Telepathy points. "+
"A telepathic link remains active until you shut it "+
"down, or for fifteen minutes, whichever is greater. You "+
"may pay an additional 2 points per link to maintain it "+
"past the fifteen minute duration. If you have already "+
"established multi-party communication, this capability is "+
"extended at no additional point cost if you pay to extend "+
"the duration of all of its constituent links. "+
"The subject must be within direct visual range of "+
"you when the link is first established. To keep the link "+
"active, subjects must remain within a range equal to your "+
"Telepathy rating times 1000m. If the distance between "+
"you and a subject exceeds that distance even briefly, the "+
"link is severed. "+
"Taking part in a telepathic link is only a little more "+
"distracting than listening to people talk, and does not "+
"hamper you or your subjects as you perform other tasks. "+
"A subject who does not want to hear you talking in "+
"their head can attempt a Composure test, with your "+
"Telepathy pool as the Difficulty. If successful, the link is "+
"briefly established, then broken."
        },
        {
            id: 94,
            name: "Teleportation",
            category: "Physical",
            isInvestigative: false,
            position: [5, 5],
            subPosition: [1, 4],
            description: "You can disappear from one location and instantly "+
"reappear in another. Doing so requires a Teleportation "+
"test against a Difficulty derived from the distance traveled "+
"and your familiarity with your chosen destination. Add "+
"all pertinent factors from the table below to get the "+
"Difficulty of your attempt. "+
"You can't intentionally teleport into the middle of an "+
"object, barrier, or person. If an object or barrier has "+
"been moved to your desired destination since you last "+
"familiarized yourself with it, you will instead appear at "+
"the nearest safe location. "+
"Like any other power(except where explicitly noted) "+
"teleportation takes an action in combat. Therefore, you "+
"can't both attack and teleport, or vice versa, during the "+
"same round. (This is our roundabout way of confirming "+
"that, sorry, you can't do the cool thing that blue guy with "+
"the tail in those comics and movies does.) "+
            "Legal Ramifications: Teleportation is an Article 18 "+
"power; see p. 123."
        },
        {
            id: 95,
            name: "Telescopic Vision",
            category: "Focus",
            isInvestigative: false,
            position: [4, 6],
            subPosition: [2, 4],
            description: "You can selectively alter your vision to see distant objects "+
"as if they are right in front of you. This allows you to, "+
            "among other things, conduct surveillance without the "+
"need for cumbersome equipment. The range of this sense "+
"depends on your rating. "+
"Telescopic Vision does not allow you to see through "+
"objects, but if you have X-Ray Vision as well, you can "+
"combine the two powers. "+
"If you spend a point of Telescopic Vision, you can "+
"ignore the effects of Range (p. 94) for one Shooting or "+
"Blast attack. "+
"Legal ramifications: Several mutants have been "+
"successfully prosecuted for using telescopic vision to "+
"violate Peeping Tom statutes."
        },
        {
            id: 96,
            name: "Thermal Vision",
            isInvestigative: true,
            position: [4, 5],
            subPosition: [2, 4],
            description: "You can, at will, alter your perceptions so that you see "+
"the infrared spectrum instead of the normal visible "+
"spectrum. This allows you to see the heat signatures "+
"given off by creatures and objects, as if you are peering "+
"through a thermographic imager. Thermal vision grants "+
"you a limited ability to see through walls, provided that "+
"the walls are about as thin as those in a normal house. "+
"You see only heat sources, and their rough shapes, on the "+
"other side of the wall. "+
"Legal ramifications: In what many regard as a "+
"legal inconsistency, use of thermographic imagers is not "+
"regarded as an unreasonable search. Evidence procured "+
"through it is fully admissible without a search warrant. "+
"The ruling predates the SME, but has since been "+
"applied to mutant powers as well as to ordinary thermal "+
"technology."
        },
        {
            id: 97,
            name: "Threat Calculus",
            category: "Focus",
            isInvestigative: false,
            position: [5, 3],
            subPosition: [1, 1],
            description: "You are able to predict what physical moves the people "+
"around you are about to make. So long as you are able "+
"to observe a subject, they can never make a physical "+
"move that surprises you. If another character makes a "+
"move, you may spend 3 Threat Calculus to interrupt "+
"their action with a move of your own. You can only use "+
"Threat Calculus once per combat round (it doesn't give "+
"you extra actions, it just lets you move your own action up "+
"in response). "+
"When you or a comrade gets hit by a blast attack "+
"whose base damage was increased by a point spend, "+
            "you may spend 1 Threat Calculus point to cancel that "+
"extra damage against you, or 2 Threat Calculus points to "+
"cancel it against another target. "+
"You can also spend a point of Threat Calculus to "+
"determine the amount of force a target is willing to use to "+
"resist arrest. You can tell at a glance if they won't resist, "+
            "if they'll just try to flee, if they'll fight back, if they'll use "+
"lethal force, or if they're overwhelmingly dangerous. "+
"Threat Calculus does not protect you from actions "+
"taken by people you are unaware of."
        },
        {
            id: 98,
            name: "Touch",
            isInvestigative: true,
            position: [2, 2],
            subPosition: [1, 2],
            description: "Your sense of touch is incredibly sensitive, even through a "+
"set of extra-thin latex gloves. You can find minute pieces "+
"of trace evidence with your fingertips, detect tiny flaws "+
"in objects, and differentiate between materials by the feel "+
"of their surfaces. In past cases, you have performed feats "+
"such as the following. "+
"�	 Finding well-hidden safes and compartments. "+
"�	 Determining that a door knob at a crime scene had "+
"been recently replaced, leading to the discovery of a "+
"damaged knob in the suspect's possession. "+
"�	 From the depth of microscopic indentations, "+
"    determining that a document supposedly made by a "+
"particular antique typewriter was in fact produced by "+
"a different model."
        },
        {
            id: 99,
            name: "Toxin Immunity (Ingested)",
            category: "Physical",
            isInvestigative: false,
            position: [3, 4],
            subPosition: [4, 1],
            description: "Your enhanced liver processes toxins that would kill an "+
"ordinary person, allowing them to pass through your "+
"body without harm. The toxins are neutralized in the "+
"process, so you can urinate in the serene confidence that "+
"you're not introducing dangerous substances into the "+
"water supply. "+
"Whenever you ingest a poisonous substance, including "+
"bacterial toxins from food poisoning, spend 2 Toxin "+
"Immunity (Ingested) points to ignore any damage and "+
"ill effects you would otherwise incur, without having to "+
"make a Health test."
        },
        {
            id: 100,
            name: "Toxin Immunity (Inhaled)",
            category: "Physical",
            isInvestigative: false,
            position: [1, 4],
            subPosition: [4, 1],
            description: "Microscopic mutant filtration cells in the lining of "+
"your lungs immediately block the absorption of toxic "+
"substances into your bloodstream. Whenever you are "+
"exposed to gaseous or powdered toxins, spend 2 Toxin "+
"Immunity(Inhaled) points to ignore any damage and "+
"ill-effects you would otherwise incur, without having to "+
"make a Health test. The ability also protects you against "+
"smoke inhalation."
        },
        {
            id: 101,
            name: "Tracking",
            category: "Focus",
            isInvestigative: false,
            position: [3, 6],
            subPosition: [3, 2],
            description: "If provided with a scent sample from a living subject, "+
"and a location where the subject recently was, you can "+
"track them to their current location. Your tracking "+
"sense is so highly developed that methods used to throw "+
"off bloodhounds don't work on you. Even if the quarry "+
"crosses a river or masks their scent with perfume, you'll "+
"still find them-although you may be delayed as you "+
"search for the real trail. "+
"If finding a subject's location provides a clue necessary "+
"to the solving of a case, you automatically succeed. "+
                "Otherwise, you must spend points to find the present "+
"location of other subjects. The cost varies according to "+
"the time elapsed between the subject's presence at your "+
"start point, and the beginning of your tracking effort. "+
"(Where durations on the chart overlap, use the most "+
"forgiving option.)  "+
"Although you automatically succeed if you spend "+
"the appropriate number of points, you may face other "+
"obstacles along the way, from bears to bear traps. "+
"The above costs assume a mostly natural environment. "+
"To track in an urbanized environment, double the cost."
        },
        {
            id: 102,
            name: "Translation",
            isInvestigative: true,
            position: [6, 1],
            subPosition: [4, 1],
            description: "You comprehend all languages, written or spoken, living "+
"or dead. When confronted with an unfamiliar language, "+
            "you must hear or read about a hundred words of it. "+
"Hieroglyphic or symbolic languages require a sample "+
"size of two hundred symbols, and a study time of ten to "+
"twenty minutes. You can also pick up on the underlying "+
"meaning or intent of slang and references, even if you "+
"don't have all the cultural clues needed to untangle them. "+
"With a Push, you can convincingly emulate a particular "+
"accent or style of speech."
        },
        {
            id: 103,
            name: "Transmutation",
            category: "Focus",
            isInvestigative: false,
            position: [2, 3],
            subPosition: [2, 2],
            description: "You can alter the elemental composition of inanimate "+
"objects. To do so, test Transmutation against a Difficulty "+
"of 4, or the number of steps separating the elements in "+
"the following list, whichever is greater. "+
"Graphite "+
"Sulfur "+
"Calcium "+
"Titanium "+
"Iron "+
"Nickel "+
"Copper "+
"Aluminum "+
"Silver "+
"Tin "+
"Platinum "+
"Gold "+
"Lead "+
"You can transmute 100 g or less of material per day, "+
            "based on the weight of the substance before it is changed, "+
            "without strain. To transmute more than this in a single "+
"day, pay 3 Transmutation points for each additional 100g. "+
"Transmuted elements are identifiable as such using a "+
"simple Herceg-Mikkelson test, which any trained person "+
"can quickly administer with the aid of an inexpensive "+
"chemical solution. Transmuted precious metals typically "+
"fetch 1% of the price of their naturally-occurring "+
"counterparts and are not used in coinage or luxury items. "+
    "However, many mutants with this power make a living "+
"transmuting base metals into precious ones for industrial "+
"use. "+
"You may transmute part of an object; turning iron "+
"into calcium causes significant damage to any machine "+
"made of steel."
        },
        {
            id: 104,
            name: "Venom (Bite)",
            category: "Physical",
            isInvestigative: false,
            position: [3, 1],
            subPosition: [4, 4],
            description: "By biting an opponent's exposed flesh, you can inject "+
"them with a powerful neurotoxin. At the time of the bite, "+
            "spend any number of Venom (Bite) points to increase the "+
"Difficulty of all later Health tests made by your victim "+
"while attempting to resist the effects of the toxin. This "+
"number is referred to as the bite's Toxicity. "+
"One minute after the bite, the victim must make a "+
"Health test against a Difficulty of 4 plus the Toxicity. On "+
"a failure, the victim immediately succumbs to the toxin. "+
"On a success, they still have one half hour per point of "+
"Toxicity before the toxin strikes. "+
"When the toxin takes effect, the victim makes a second "+
"Health test, again with a Difficulty of 4 plus the Toxicity. "+
"On a failure, their Health pool is immediately reduced "+
"to -9, unless they are already at -9 or less, in which case "+
"they die. On a success, their Health pool is reduced by "+
"the bite's Toxicity. "+
"In either case, the victim cannot refresh Health points "+
                "(except through the Healing power) and continues to "+
"lose 1 Health every 3 hours until they are administered "+
"an antivenin. Antivenins to mutant powers are too "+
"perishable and expensive to appear in standard first aid "+
"kits, so victims will need to find them at hospitals. "+
"HCIU officers who have reason to believe they'll be "+
"facing venomous suspects can requisition supplies of "+
"antivenin. "+
"Multiple bites against a single target are redundant. "+
"Unless you also have Fangs, the damage modifier "+
"from a bite attack is -3."
        },
        {
            id: 105,
            name: "Venom (Spit)",
            category: "Physical",
            isInvestigative: false,
            position: [3, 1],
            subPosition: [4, 2],
            description: "Glands in your throat produce a powerful poison, which "+
"you can expel as a projectile onto an opponent's exposed "+
"eyes or mouth. The range for this ability is your Venom "+
                "(Spit) pool in meters. Test Venom (Spit) against your "+
"target's Hit Threshold. If successful, you do damage with "+
"a +1 modifier. "+
                "Also, until they clear the gob of toxic mucus from "+
"their face, your opponent is wracked with pain and "+
"suffers blurred vision. To clear away the mucus, they "+
                "(or a character coming to their aid) must make a Medic "+
"test, with the result of your Venom (Spit) attack as the "+
"difficulty. If no one aids the target, they will attempt to "+
"clear the mucus instinctively, even if they lack the ability "+
"and have little chance of success. They can suppress this "+
"instinct only on a Composure test with the result of your "+
"Venom (Spit) attack as the difficulty. If successful, they "+
"may ignore the pain, but it and the blurred vision increase "+
"the Difficulties of all actions the target undertakes by 2. "+
"After ten minutes, the Difficulty of the Medic test "+
"to clear the mucus decreases by 2, and it continues to "+
"decrease by 2 at ten minute intervals. When it drops to 0, "+
            "the venom's effect ceases. "+
"This ability is useless against a target wearing a helmet "+
"or other protection over their entire face."
        },
        {
            id: 106,
            name: "Venom (Stinger)",
            category: "Physical",
            isInvestigative: false,
            position: [3, 1],
            subPosition: [4, 3],
            description: "Your spinal column houses not only your spinal cord, "+
"but a meter- long, thin, prehensile organ terminating in "+
        "a barbed stinger. The stinger delivers a paralytic poison "+
"which immobilizes your victims. "+
"By spending 2 Venom (Stinger) points, you can cause "+
"this organ to emerge from your first thoracic vertebra. It "+
"costs 2 Venom(Stinger) points to retract. "+
"You can attack your enemies with this organ when "+
"close enough to Scuffle with them. Test Venom (Stinger) "+
"against your opponent's Hit Threshold. On a successful "+
"hit, you do no damage, but force the victim to make a "+
"Health test with the result of your Venom (Stinger) attack "+
"as the difficulty. On a failure, they lose an additional "+
"2 Athletics points whenever they make an Athletics, "+
   "Driving, Infiltration, Scuffling, or Shooting test, or makes "+
"a test of a mutant power. When the victim drops to 0 "+
"Athletics points, they are paralyzed. Although conscious, "+
    "they are unable to move. (If they have no Athletics pool  "+
"when you first hit them, they are paralyzed immediately.) "+
"A victim may not refresh Athletics while paralyzed. "+
"Every ten minutes, they may make a new Health test, at "+
"first against the result of your Venom (Stinger) attack. After "+
"every subsequent ten minutes, the Difficulty decreases by "+
"2. On a successful result, the effect ends. "+
"The toxin's effects may be ended at any time with a "+
"successful application of the Cure Disease power, against "+
"a Difficulty of 4."
        },
        {
            id: 107,
            name: "Wall Crawling",
            category: "Physical",
            isInvestigative: false,
            position: [2, 1],
            subPosition: [3, 2],
            description: "Tiny filaments protrude from your palms and the "+
"undersides of your fingers, allowing you to cling to walls "+
"and ceilings without other aid. You automatically succeed "+
"at any climbing attempt. Your rate of speed while climbing "+
"depends on your Wall Crawling rating, as follows. "+
"You can spend Wall Crawling points to resist attempts to "+
"pull you off the wall. Weather conditions or surfaces like "+
"glass may require you to spend Wall Crawling points to "+
"keep climbing. "+
"If you fall within reach of a surface, you may make a "+
"Wall Crawling test (Difficulty 4) to slow your descent and "+
"either grab onto the wall or land without damage. "+
"You may try to pick up items with Wall Crawling; "+
"spend Wall Crawling points as Filch points in such a test."
        }, 
        {
            id: 108,
            name: "Water Blast",
            category: "Focus",
            isInvestigative: false,
            position: [1, 5],
            subPosition: [4, 3],
            description: "You can emit a high-pressure stream of water from your "+
"fingertips. This is a blast power; see sidebar, p. 45. "+
"On a successful hit, your opponent is knocked back "+
"by the spray, moving 1m directly away from you, in the "+
"same direction as your blast, for every point of difference "+
"between your Water Blast result and their Hit Threshold. "+
"If this knocks them into a solid barrier, such as a wall, "+
            "they lose an additional 2 Health points. "+
"An opponent who is suitably braced and prepared for "+
"your blast may try to resist in a contest of Athletics vs "+
"your Water Blast. If you win, the opponent is knocked "+
"over and pushed away. "+
"Water Blast is countered by Kinetic Energy Dispersal."
        },
        {
            id: 109,
            name: "Water Manipulation",
            category: "Focus",
            isInvestigative: false,
            position: [1, 5],
            subPosition: [4, 1],
            description: "You can shape water, causing it to cohere into a bounded," +
                "though still liquid, form, and directing its movements. " +
                "Here are some of the stunts you can perform and " +
                "accompanying Difficulties. " +
                "After animating a humanoid shape from water, you can " +
                "direct it like a puppet to fight your enemies. Use your " +
                "Water Manipulation ability as its Scuffling; its liquid fists " +
                "carry a Damage Modifier of +0. It cannot be damaged " +
                "by ordinary weapons, but loses the ability to move if " +
                "the temperature drops to 0� C or less. You must remain " +
                "in direct visual contact with it, and can do nothing but " +
                "direct its movements. If you are hit, " +
                "entangled or forced to take other " +
                "significant action, the water sloshes " +
                "into a puddle and drains away."
        },
        {
            id: 110,
            name: "Webbing",
            category: "Physical",
            isInvestigative: false,
            position: [2, 1],
            subPosition: [3, 1],
            description: "You secrete sticky proteinaceous "+
"fibers from glands located in your "+
"forearms. Though lighter than rope, "+
            "the web material possesses a tensile "+
"strength comparable to steel. The "+
"webbing has three primary uses. "+
                "Adhesive: You can secrete a sticky "+
"blob of webbing, which you can "+
"use as a powerful glue to stick two "+
"objects together. For example, you "+
"could use it to quickly stick a GPS "+
"device on the bottom of a suspect's "+
"car. Pay 1 or more Webbing points "+
"each time you do this. The glue "+
"remains insoluble for thirty minutes "+
"for each point you spend, after "+
"which it quickly biodegrades into a "+
"watery goo. "+
                "Movement: You can cast the web "+
"up above you and then climb it like "+
"you would a rope, scaling up or rappelling down sheer "+
"surfaces. The sticky webbing adheres to any ordinary "+
"surface, supporting your weight even more securely than "+
"would a grappling hook. Spinning a length of climbingsuitable webbing costs you 2 Webbing points. Making "+
"difficult maneuvers using your webbing requires the "+
"Athletics ability. Swinging from web to web is possible "+
"but very difficult, with a base Difficulty of 6, which can "+
"be additionally complicated by other factors, such as "+
"wind speed and storm conditions. "+
                "Restraints: You can restrain subjects by spraying "+
"them with a wide arc of webbing, which keeps them "+
"immobilized for a cost of 2 Webbing points for every "+
"two hours you want the webbing to retain its strength. "+
"Hitting a moving target with your webbing requires a "+
"successful Shooting test. If you shoot webbing at a subject "+
"and miss, you still have to pay the 2 points. A webbed "+
"subject can make an Athletics or Strength test to get free, "+
            "with a Difficulty equal to 4 plus your Webbing pool as of "+
"the moment you began to spin the restraint webbing (that "+
"is, before you spent the 2 points to activate it). Another "+
"person who is not caught in the web can carefully cut a "+
"restrained person out of it with a utility knife or other "+
"blade of similar sharpness, though this takes several "+
"minutes."
        },
        {
            id: 111,
            name: "Wind Control",
            category: "Focus",
            isInvestigative: false,
            position: [1, 3],
            subPosition: [4, 2],
            description: "Through force of will, you can increase or decrease "+
"wind speeds. To alter prevailing wind velocity, test Wind "+
"Control against a Difficulty equal to 4, plus the number of "+
"steps of separation from the present state to your desired "+
"state, on the following list. "+
"�	 Calm "+
"�	 Breeze "+
"�	 Strong Breeze "+
"�	 Near Gale "+
"�	 Gale(light structure damage begins) "+
"�	 Storm(trees uprooted; moderate structure damage) "+
"�	 Violent Storm(heavy structure damage) "+
"�	 Hurricane(structures may be obliterated) "+
 "The area affected is a sphere with your current range as "+
    "its diameter, and your position as its center point. Your "+
"miniature storm moves as you do. "+
"Having generated your miniature wind storm, you "+
"must spend 1 Wind Control point per minute to keep it "+
"going. "+
"When your storm, violent storm or hurricane first "+
"appears, everyone inside it (including you) must make "+
"an Athletics test against a Difficulty equal to your Wind "+
"Control result. Those who fail lose a number of Health "+
"points equal to the difference between their results and "+
"the Difficulty, from flying debris. "+
"Combat movement rates within a storm, violent storm "+
"or hurricane, including your own, are halved. "+
"You can also create, in the same sphere, an area of "+
"highly variable wind speeds. These make it more difficult "+
"for users of missile weapons to predictably hit their "+
"targets. (Even in strong winds, a trained shooter can "+
"compensate, as long as the winds remain consistent.) Test "+
"Wind Control against a Difficulty of 6; if successful, the "+
"effective Hit Threshold of any target within the sphere "+
"increases by 2."
        },
        {
            id: 112,
            name: "X-Ray Vision",
            isInvestigative: true,
            position: [4, 5],
            subPosition: [2, 3],
            description: "You can alter your normal vision to see through solid "+
"objects of a total thickness of up to 1 meter, at a maximum "+
"distance equal to your normal vision. You can adjust "+
"your vision to concentrate on the depth of field you're "+
"interested in, within this range. Thickness is treated "+
"cumulatively if you're seeing through multiple objects "+
                "spaced some distance apart: you can see through a six " +
            "inch wall if no other obstructions sit between you and "+
"your target, but will be thwarted if a truck packed tight "+
"with cargo pulls up in front of it. Any thickness of lead "+
"will block the power completely. "+
"When using this ability, you emit trace quantities of "+
"radiation, which is detectable with a sensitive Geiger "+
"counter. "+
"Legal ramifications: Several mutants have been "+
"sued in cases where they are alleged to have used their "+
"X-Ray Vision to watch a particular subject for sustained "+
"periods, causing the subject to develop cancer. Although "+
"these cases have yet to wend their way through the "+
"courts, HCIU officers with X-Ray Vision must follow "+
"strict health guidelines to minimize the amount of time "+
"any living organism is exposed to their radiation."
        },
        // GRFs
        // TODO: how to do stress penalties? They are conditional, so might need special flags
        {
            id: 113,
            isGRF: true,
            name: "Addictive Personality",
            isInvestigative: false,
            position: [5, 1],
            subPosition: [4, 2],
            resistanceAbility: "Composure",
            description: "You like thrills, risk, and activities that give you " +
"accelerating levels of stimulation when repeated. " +
"You've been known to drink a few too many, and also " +
"to experiment with soft illicit substances. You always " +
"have a bet down on an upcoming game. When you surf " +
"the internet, you keep going until you�re bleary-eyed, " +
"always looking for another cool site or cache of very " +
"specific X-rated material. When you fire up a new video " +
"game, you can't stop until you've beaten the damn thing. " +
"Your brain doesn't kick into gear until you've had your " +
"morning dose of caffeine, which you probably repeat " +
"throughout the day."
            // addiction -1
        },
        {
            id: 114,
            isGRF: true,
            name: "Asthma",
            isInvestigative: false,
            position: [1, 3],
            subPosition: [4, 3],
            resistanceAbility: "Health",
            description: "If your GRF manifests you will have trouble breathing " +
"after exposure to pollutants, common allergens, changes " +
"in temperature, and excesses of humidity. When you " +
"catch a cold, breathing problems linger long after the " +
"infection clears your system.",           
            // medical -1
        },
        {
            id: 115,
            isGRF: true,
            name: "Cortisol Elevation",
            isInvestigative: false,
            position: [3, 0],
            subPosition: [4, 3],
            resistanceAbility: "Composure",
            description: "Your fight or flight response has over-tuned itself. Right " +
"now you're jumpy and prone to sleepless nights. Should " +
"matters get worse, you might respond to danger with debilitating panic."            
            // fear -1 (if you have not yet made a physical test this episode) OR rage -1 
        },
        {
            id: 116,
            isGRF: true,
            name: "Dissociation",
            isInvestigative: false,
            position: [2, 2],
            subPosition: [2, 3],
            resistanceAbility: "Composure",
            description: "This condition causes people to withdraw from others " +
"emotionally. As it becomes more extreme, they see " +
"the world as essentially unreal, and their actions as meaningless."            
            // home life -1
        },
        {
            id: 117,
            isGRF: true,
            name: "Empathy Loop",
            isInvestigative: false,
            position: [5, 2],
            subPosition: [1, 4],
            resistanceAbility: "Composure",
            description: "People with the empathy loop condition respond to " +
"others' strong emotions as a contagion. They feel the " +
"feelings of those around them so acutely that they either " +
"mirror or reject them. They may act out, performing an " +
"exaggerated version of the responses the other person is " +
"probably successfully suppressing. Or they shut down " +
"entirely, building a wall of an apparent indifference that " +
"may be mistaken for dissociation."
            // home life -1
        },
        {
            id: 118,
            isGRF: true,
            name: "GABA Oversufficiency",
            isInvestigative: false,
            position: [3, 2],
            subPosition: [2, 3],
            resistanceAbility: "Composure",
            description: "If your GRF manifests your brain will produce an over-flow " +
"of gamma-Aminobutyric acid, a neurotransmitter " +
"suppressor essential to mood regulation. This condition " +
"shortens and lessens positive moods, leading to a sense " +
"of numbness and melancholy. Subjects often seek to lift " +
"themselves with drugs or alcohol, which may provide " +
"momentary relief but in the end reinforces the effect."
            // addiction -1
        },
        {
            id: 119,
            isGRF: true,
            name: "Forced Genetic Drift",
            isInvestigative: false,
            position: [5, 1],
            subPosition: [1, 3],
            resistanceAbility: "Health",
            description: "Incipient: When stressed, you radiate an energy field " +
"that alters human cellular division. At low levels, this " +
"field causes skin lesions, headaches, and slows natural " +
"healing processes. More intense fields can, in rare " +
"cases, cause mutations to develop in those around you, " +
"but cancers are a far more likely result of exposure " +
"to advanced Forced Genetic Drift sufferers. Subjects " +
"typically sequester themselves away from other people, although mutants " +
"are much less likely to suffer the ill effects of Forced Genetic Drift than " +
"non-mutants. Some scientists theorise that those " +
"who develop this GRF are, in effect, infection vectors for the 'ghost flu' that " +
"preceded the Sudden Mutation Event, and speculate about some 'mutant " +
"zero' or cosmic energy field that caused the initial spate of mutations. However, " +
"all the mutants who developed powers after exposure to a Forced Genetic " +
"Drift field also contracted the ghost flu ten years ago, so there's no conclusive " +
"proof that this condition can turn non-mutants to mutants."
            // home life -1
        },
        {
            id: 120,
            isGRF: true,
            name: "Insula Skew",
            isInvestigative: false,
            position: [2, 5],
            subPosition: [4, 4],            
            resistanceAbility: "Composure",
            description: "Subjects of this GRF undergo a " +
"cellular mutation in the insular cortex triggering material acquisitiveness. " +
"Some may flaunt their wealth, while others hide it all away. Either way, an " +
"evidence locker full of cash and items you can trade into cash might entice " +
"you with a siren call."
            // corruption -1
        },
        {
            id: 121,
            isGRF: true,
            name: "Limbic Hypertrophy",
            isInvestigative: false,
            position: [5, 3],
            subPosition: [1, 3],
            resistanceAbility: "Composure",
            description: "Your amygdala, the almond-shaped " +
"part of your brain responsible for triggering of survival instinct, might be provoking you to " +
"quicker and more intense bouts of anger."
            // rage -1
        },
        {
            id: 122,
            isGRF: true,
            name: "Low Impulse Control",
            isInvestigative: false,
            position: [6, 1],
            subPosition: [3, 3],
            resistanceAbility: "Composure",
            description: "People manifesting this condition have a hard time paying " +
"attention to the voice in their head that says, \"You�ll get " +
"into big trouble if you do this.\""   
            // Roll a die during character generation. even: rage -1, odd: corruption - 1
        },
        {
            id: 123,
            isGRF: true,
            name: "Megalomania",
            isInvestigative: false,
            position: [5, 2],
            subPosition: [4, 4],
            resistanceAbility: "Composure",
            description: "You may one day succumb to an outsized perception " +
"of your own importance and accomplishments. Your " +
"present engagingly cocky and assertive attitude could " +
"eventually metastasize into aggrieved and narcissistic ranting."
            // choose between obsession -1 or corruption -1.
            // when you take a stress card bearing the other tag, you acquire that penalty as well
        },
        {
            id: 124,
            isGRF: true,
            name: "Meta-Persona Identity Disorder",
            isInvestigative: false,
            position: [6, 0],
            subPosition: [3, 2],            
            resistanceAbility: "Composure",
            description: "You have the urge to create an alter-ego, hiding your " +
"powers behind a mask or costume. If your Stress Penalty is " +
"Obsession, then your instinct is to be a costumed vigilante, " +
"bringing justice to those who consider themselves above " +
"the law. If it's Corruption, then you must fight the secret desire to be a villain."
            // Roll a die during character generation. even: obsession -1, odd: corruption - 1
        },
        {
            id: 125,
            isGRF: true,
            name: "Messiah Complex",
            isInvestigative: false,
            position: [2, 3],
            subPosition: [4, 4],
            resistanceAbility: "Composure",
            description: "When people are in trouble, you feel that you are the one " +
"who can and must save them. Should your GRF activate, what now registers as " +
                "altruism could turn into a tendency to blame yourself for " +
"everything and forgive yourself for nothing."
            // obsession - 1
        },
        {
            id: 126,
            isGRF: true,
            name: "Personality Drift",
            isInvestigative: false,
            position: [5, 5],
            subPosition: [3, 2],
            resistanceAbility: "Composure",
            description: "In Personality Drift patients the complex set of genetic " +
"switches that determine typical responses to stimuli unlock and unpredictably shift. They behave like radically " +
"different people from day to day. One week you might compulsively seek dangerous pleasures, the next you " +
"recoil from all risk. In the end you might identify your various shifts in response as distinct personae, or think " +
"of yourself as a single individual who at any moment is capable of absolutely anything."
            /*  at the beginning of each scenario 
            after the first, roll a die, gaining the corresponding 
            penalty for the duration: 1) Addiction 2) Corruption 3)
            Fear 4) Home Life 5) Obsession 6) Rage*/
        },
        {
            id: 127,
            isGRF: true,
            name: "Plasma Deficiency",
            isInvestigative: false,
            position: [4, 1],
            subPosition: [2, 3],
            resistanceAbility: "Health",
            description: "Your circulatory system doesn't produce enough blood " +
"plasma. Rumor has it that a few mutants with this GRF " +
"wind up waylaying victims and drinking their blood."            
            // medical - 1
        },
        {
            id: 128,
            isGRF: true,
            name: "Scleroderma",
            isInvestigative: false,
            position: [2, 1],
            subPosition: [1, 3],
            resistanceAbility: "Health",
            description: "You are at a heightened risk of a chronic disease in which " +
"excess collagen gathers in deposits in your skin. Advanced cases lead to renal failure."            
            // medical - 1
        },
        {
            id: 129,
            isGRF: true,
            name: "Sensory Overload",
            isInvestigative: false,
            position: [6, 6],
            subPosition: [1, 1],
            resistanceAbility: "Composure",
            description: "If this GRF manifests, input from your five senses ramps " +
"up to a distracting, perhaps even alarming or painful degree."
            // fear - 1
        },
        {
            id: 130,
            isGRF: true,
            name: "Skeletal Mineralization",
            isInvestigative: false,
            position: [3, 5],
            subPosition: [3, 1],
            description: "If your GRF ever kicks in, the calcium in your bones " +
"will start to transform into iron, slowing your movement. " +
"Fully advanced cases result in paralysis.",
            resistanceAbility: "Health"
            // medical - 1
        },
        {
            id: 131,
            isGRF: true,
            name: "Trance Susceptible",
            isInvestigative: false,
            position: [4, 3],
            subPosition: [1, 2],
            resistanceAbility: "Composure",
            description: "This GRF may leave you vulnerable to hypnotists and " +
"mutants with mind-affecting powers."
            // fear - 1
        },
        {
            id: 132,
            isGRF: true,
            name: "Watcher Syndrome",
            isInvestigative: false,
            position: [4, 6],
            subPosition: [2, 1],
            resistanceAbility: "Composure",
            description: "Should your GRF activate, you'll retreat from the " +
"world through the safe distance of your camera or other " +
"surveillance device. You find that you�d sooner observe " +
"events than participate in them. " +
"Great if you're on stake-out duty; terrible when you have to testify in court or save " +
"your faltering marriage."
            /*Choose between Obsession -1 or Home 
            Life -1. When you take a Stress card bearing the other tag, 
            you acquire that Stress penalty as well.*/
        },
    ], 
    mutantPowerLinks: [
        {
            // hearing - olfactory center
            id: 1,
            isDotted: true,
            powerIDs: [
                37, 60
            ]
        },
        {
            // hearing - insula skew
            id: 2,
            isDotted: false,
            powerIDs: [
                37, 120
            ]
        },
        {
            // command mammals - environmental awareness
            id: 3,
            isDotted: false,
            powerIDs: [
                13, 27
            ]
        },
        {
            // environmental awareness - tracking
            id: 4,
            isDotted: false,
            powerIDs: [
                27, 101
            ]
        },
        {
            // olfactory center - tracking
            id: 5,
            isDotted: false,
            powerIDs: [
                60, 101
            ]
        },
        {
            // olfactory center - natural weaponry
            id: 6,
            isDotted: true,
            powerIDs: [
                60, 56
            ]
        },
        {
            // olfactory center - watcher syndrome
            id: 7,
            isDotted: false,
            powerIDs: [
                60, 132
            ]
        },
        {
            // night vision - watcher syndrome
            id: 8,
            isDotted: false,
            powerIDs: [
                57, 132
            ]
        },
        {
            // microvision - night vision
            id: 9,
            isDotted: false,
            powerIDs: [
                55, 57
            ]
        },
        {
            // microvision - telescopic vision
            id: 10,
            isDotted: false,
            powerIDs: [
                55, 95
            ]
        },
        {
            // thermal vision - watcher syndrome
            id: 11,
            isDotted: false,
            powerIDs: [
                96, 132
            ]
        },
        {
            // watcher syndrome - spatial awareness
            id: 12,
            isDotted: false,
            powerIDs: [
                132, 81
            ]
        },
        {
            // earth control - spatial awareness
            id: 13,
            isDotted: false,
            powerIDs: [
                20, 81
            ]
        },
        {
            // earth control - magnetism
            id: 14,
            isDotted: false,
            powerIDs: [
                20, 53
            ]
        },
        {
            // spatial awareness - telekinesis
            id: 15,
            isDotted: false,
            powerIDs: [
                81, 92
            ]
        },
        {
            // telekinesis - sensory overload
            id: 16,
            isDotted: false,
            powerIDs: [
                92, 129
            ]
        },
        {
            // force field - sensory overload
            id: 17,
            isDotted: false,
            powerIDs: [
                33, 129
            ]
        },
        {
            // spatial awareness - teleportation
            id: 18,
            isDotted: false,
            powerIDs: [
                81, 94
            ]
        },
        {
            // water blast - water manipulation
            id: 19,
            isDotted: false,
            powerIDs: [
                108, 109
            ]
        },
        {
            // water manipulation - swimming
            id: 20,
            isDotted: false,
            powerIDs: [
                109, 89
            ]
        },
        {
            // insula skew - sonar
            id: 21,
            isDotted: false,
            powerIDs: [
                120, 79
            ]
        },
        {
            // sonar - sonic blast
            id: 22,
            isDotted: false,
            powerIDs: [
                79, 80
            ]
        },
        {
            // sonar - gills
            id: 23,
            isDotted: true,
            powerIDs: [
                79, 34
            ]
        },
        {
            // sonic blast - heat blast
            id: 24,
            isDotted: false,
            powerIDs: [
                80, 38
            ]
        },
        {
            // flight - heat blast
            id: 25,
            isDotted: false,
            powerIDs: [
                32, 38
            ]
        },
        {
            // natural weaponry - skeletal mineralization
            id: 26,
            isDotted: false,
            powerIDs: [
                56, 130
            ]
        },
        {
            // skeletal mineralization - limb extension
            id: 27,
            isDotted: false,
            powerIDs: [
                130, 52
            ]
        },
        {
            // thermal vision - x-ray vision
            id: 28,
            isDotted: false,
            powerIDs: [
                96, 112
            ]
        },
        {
            // light control - x-ray vision
            id: 29,
            isDotted: false,
            powerIDs: [
                49, 112
            ]
        },
        {
            // light control - light blast
            id: 30,
            isDotted: false,
            powerIDs: [
                49, 48
            ]
        },
        {
            // light control - invisibility
            id: 31,
            isDotted: false,
            powerIDs: [
                49, 46
            ]
        },
        {
            // light blast - kinetic energy dispersal
            id: 32,
            isDotted: true,
            powerIDs: [
                48, 47
            ]
        },
        {
            // invisibility - personality drift
            id: 33,
            isDotted: false,
            powerIDs: [
                46, 126
            ]
        },
        {
            // illusion - personality drift
            id: 34,
            isDotted: false,
            powerIDs: [
                41, 126
            ]
        },
        {
            // alter form - personality drift
            id: 35,
            isDotted: false,
            powerIDs: [
                2, 126
            ]
        },
        {
            // alter form - impersonate
            id: 36,
            isDotted: false,
            powerIDs: [
                2, 42
            ]
        },
        {
            // command fish - swimming
            id: 37,
            isDotted: false,
            powerIDs: [
                11, 89
            ]
        },
        {
            // gills - swimming
            id: 38,
            isDotted: false,
            powerIDs: [
                34, 89
            ]
        },
        {
            // gills - toxin immunity (inhaled)
            id: 39,
            isDotted: true,
            powerIDs: [
                34, 100
            ]
        },
        {
            // deplete oxygen - toxin immunity (inhaled)
            id: 40,
            isDotted: false,
            powerIDs: [
                16, 100
            ]
        },
        {
            // regeneration - toxin immunity (inhaled)
            id: 41,
            isDotted: true,
            powerIDs: [
                74, 100
            ]
        },
        {
            // flight - strength
            id: 42,
            isDotted: false,
            powerIDs: [
                32, 86
            ]
        },
        {
            // regeneration - strength
            id: 43,
            isDotted: false,
            powerIDs: [
                74, 86
            ]
        },
        {
            // regeneration - messiah complex
            id: 44,
            isDotted: false,
            powerIDs: [
                74, 125
            ]
        },
        {
            // regeneration - toxin immunity (ingested)
            id: 45,
            isDotted: true,
            powerIDs: [
                74, 99
            ]
        },
        {
            // strength - limb extension
            id: 46,
            isDotted: true,
            powerIDs: [
                86, 52
            ]
        },
        {
            // limb extension - kinetic energy dispersal
            id: 47,
            isDotted: false,
            powerIDs: [
                52, 47
            ]
        },
        {
            // toxin immunity (ingested) - radiation immunity
            id: 48,
            isDotted: false,
            powerIDs: [
                99, 69
            ]
        },
        {
            // toxin immunity (ingested) - fire control
            id: 49,
            isDotted: false,
            powerIDs: [
                99, 29
            ],
            path: [
                [6, 0],
                [70, 82]
            ]
        },
        {
            // fire control - kinetic energy dispersal
            id: 50,
            isDotted: true,
            powerIDs: [
                29, 47
            ], path: [
                [-50, -60],
                [20, -230]
            ]
        },
        {
            // kinetic energy dispersal - concussion beam
            id: 51,
            isDotted: false,
            powerIDs: [
                47, 14
            ]
        },
        {
            // kinetic energy dispersal - high energy dispersal
            id: 52,
            isDotted: true,
            powerIDs: [
                47, 39
            ]
        },
        {
            // lightning - high energy dispersal
            id: 53,
            isDotted: false,
            powerIDs: [
                50, 39
            ]
        },
        {
            // high energy dispersal - gravity control
            id: 54,
            isDotted: false,
            powerIDs: [
                39, 35
            ]
        },
        {
            // reflexes - high energy dispersal
            id: 55,
            isDotted: false,
            powerIDs: [
                73, 39
            ]
        },
        {
            // reflexes - speed
            id: 56,
            isDotted: false,
            powerIDs: [
                73, 82
            ]
        },
        {
            // speed - limbic hypertrophy
            id: 57,
            isDotted: true,
            powerIDs: [
                82, 121
            ]
        },
        {
            // technokinesis - technopathy
            id: 58,
            isDotted: false,
            powerIDs: [
                90, 91
            ]
        },
        {
            // deplete oxygen - asthma
            id: 59,
            isDotted: false,
            powerIDs: [
                16, 114
            ]
        },
        {
            // wind control - asthma
            id: 60,
            isDotted: false,
            powerIDs: [
                111, 114
            ]
        },
        {
            // command birds - wind control
            id: 61,
            isDotted: false,
            powerIDs: [
                10, 111
            ]
        },
        {
            // wind control - ice blast
            id: 62,
            isDotted: true,
            powerIDs: [
                111, 40
            ]
        },
        {
            // messiah complex - healing
            id: 63,
            isDotted: false,
            powerIDs: [
                125, 36
            ]
        },
        {
            // transmutation - healing
            id: 64,
            isDotted: true,
            powerIDs: [
                103, 36
            ]
        },
        {
            // transmutation - disintegration
            id: 65,
            isDotted: false,
            powerIDs: [
                103, 19
            ]
        },
        {
            // transmutation - radiation projection
            id: 66,
            isDotted: true,
            powerIDs: [
                103, 70
            ]
        },
        {
            // radiation immunity - radiation projection
            id: 67,
            isDotted: false,
            powerIDs: [
                69, 70
            ]
        },
        {
            // radiation projection - self-detonation
            id: 68,
            isDotted: false,
            powerIDs: [
                70, 77
            ]
        },
        {
            // fire control - trance susceptible
            id: 69,
            isDotted: false,
            powerIDs: [
                29, 131
            ]
        },
        {
            // spontaneous combustion - trance susceptible
            id: 70,
            isDotted: false,
            powerIDs: [
                84, 131
            ]
        },
        {
            // spontaneous combustion - fire immunity
            id: 71,
            isDotted: false,
            powerIDs: [
                84, 30
            ]
        },
        {
            // psionic blast - threat calculus
            id: 72,
            isDotted: false,
            powerIDs: [
                67, 97
            ]
        },
        {
            // lightning decisions - limbic hypertrophy
            id: 73,
            isDotted: false,
            powerIDs: [
                51, 121
            ]
        },
        {
            // lightning decisions - threat calculus
            id: 74,
            isDotted: false,
            powerIDs: [
                51, 97
            ]
        },
        {
            // lightning decisions - cognition
            id: 75,
            isDotted: true,
            powerIDs: [
                51, 8
            ]
        },
        {
            // threat calculus - empathy loop
            id: 76,
            isDotted: false,
            powerIDs: [
                97, 117
            ]
        },
        {
            // cognition - technopathy
            id: 77,
            isDotted: false,
            powerIDs: [
                8, 91
            ]
        },
        {
            // cognition - telepathy
            id: 78,
            isDotted: false,
            powerIDs: [
                8, 93
            ]
        },
        {
            // cognition - precision memory
            id: 79,
            isDotted: false,
            powerIDs: [
                8, 66
            ]
        },
        {
            // megalomania - precision memory
            id: 80,
            isDotted: false,
            powerIDs: [
                123, 66
            ]
        },
        {
            // telepathy - detect influence
            id: 81,
            isDotted: false,
            powerIDs: [
                93, 17
            ]
        },
        {
            // suppress influence - detect influence
            id: 82,
            isDotted: false,
            powerIDs: [
                88, 17
            ]
        },
        {
            // ice blast - reduce temperature
            id: 83,
            isDotted: false,
            powerIDs: [
                40, 72
            ]
        },
        {
            // touch - reduce temperature
            id: 84,
            isDotted: false,
            powerIDs: [
                98, 72
            ]
        },
        {
            // touch - phase
            id: 85,
            isDotted: false,
            powerIDs: [
                98, 62
            ]
        },
        {
            // dissociation - phase
            id: 86,
            isDotted: false,
            powerIDs: [
                116, 62
            ]
        },
        {
            // dissociation - disintegration
            id: 87,
            isDotted: false,
            powerIDs: [
                116, 19
            ]
        },
        {
            // armor - blade immunity
            id: 88,
            isDotted: false,
            powerIDs: [
                4, 5
            ]
        },
        {
            // self-detonation - GABA oversufficiency
            id: 89,
            isDotted: false,
            powerIDs: [
                77, 118
            ]
        },
        {
            // suppress explosion - GABA oversufficiency
            id: 90,
            isDotted: false,
            powerIDs: [
                87, 118
            ]
        },
        {
            // suppress explosion - Analytic Taste
            id: 91,
            isDotted: false,
            powerIDs: [
                87, 3
            ]
        },
        {
            // secrete acid - Analytic Taste
            id: 92,
            isDotted: false,
            powerIDs: [
                76, 3
            ],
            path: [
                [0, -120],
                [-50, -60]
            ]
        },
        {
            // venom (bite) - Analytic Taste
            id: 93,
            isDotted: false,
            powerIDs: [
                104, 3
            ],
            path: [
                [50, -60],
                [-140, -140]
            ]
        },
        {
            // fire immunity - fire projection
            id: 94,
            isDotted: false,
            powerIDs: [
                30, 31
            ]
        },
        {
            // absorption - fangs
            id: 95,
            isDotted: false,
            powerIDs: [
                1, 28
            ]
        },
        {
            // empathy loop - read minds
            id: 96,
            isDotted: false,
            powerIDs: [
                117, 71
            ]
        },
        {
            // megalomania - memory alteration
            id: 97,
            isDotted: false,
            powerIDs: [
                123, 54
            ]
        },
        {
            // emotion control - low impulse control
            id: 98,
            isDotted: false,
            powerIDs: [
                21, 122
            ]
        },
        {
            // quills - blade immunity
            id: 99,
            isDotted: false,
            powerIDs: [
                68, 5
            ]
        },
        {
            // scleroderma - blade immunity
            id: 100,
            isDotted: false,
            powerIDs: [
                128, 5
            ]
        },
        {
            // entangling hair - scleroderma
            id: 101,
            isDotted: false,
            powerIDs: [
                25, 128
            ],
            path: [
                [-60, -60],
                [-10, -140]
            ]
        },
        {
            // scleroderma - wall crawling
            id: 102,
            isDotted: false,
            powerIDs: [
                128, 107
            ]
        },
        {
            // webbing - wall crawling
            id: 103,
            isDotted: false,
            powerIDs: [
                110, 107
            ]
        },
        {
            // webbing - venom (stinger)
            id: 104,
            isDotted: false,
            powerIDs: [
                110, 106
            ]
        },
        // TODO: this is a very weird line in the original. Might want custom line
        {
            // webbing - command insects
            id: 105,
            isDotted: true,
            powerIDs: [
                110, 12
            ],
            path: [
                [15, 20],
                [100, 220],
                [400, 220],
                [500, 90],
                [700, 90],
                [820, 0]
            ]
        },
        {
            // blade immunity - secrete acid
            id: 106,
            isDotted: true,
            powerIDs: [
                5, 76
            ]
        },
        {
            // spit acid - secrete acid
            id: 107,
            isDotted: false,
            powerIDs: [
                83, 76
            ]
        },
        {
            // venom (bite) - secrete acid
            id: 108,
            isDotted: false,
            powerIDs: [
                104, 76
            ]
        },
        {
            // venom (bite) - venom (stinger)
            id: 109,
            isDotted: false,
            powerIDs: [
                104, 106
            ]
        },
        {
            // venom (bite) - fangs
            id: 110,
            isDotted: true,
            powerIDs: [
                104, 28
            ]
        },
        {
            // venom (spit) - venom (stinger)
            id: 111,
            isDotted: false,
            powerIDs: [
                105, 106
            ]
        },
        {
            // venom (spit) - command amphibians & reptiles
            id: 112,
            isDotted: true,
            powerIDs: [
                105, 9
            ]
        },
        {
            // resist influence - command amphibians & reptiles
            id: 113,
            isDotted: false,
            powerIDs: [
                75, 9
            ]
        },
        {
            // command amphibians & reptiles - cortisol elevation
            id: 114,
            isDotted: false,
            powerIDs: [
                9, 115
            ]
        },
        {
            // command insects - command amphibians & reptiles
            id: 115,
            isDotted: true,
            powerIDs: [
                12, 9
            ]
        },
        {
            // fangs - plasma deficiency
            id: 116,
            isDotted: false,
            powerIDs: [
                28, 127
            ]
        },
        {
            // fangs - disease immunity
            id: 117,
            isDotted: true,
            powerIDs: [
                28, 18
            ]
        },
        {
            // possession - plasma deficiency
            id: 118,
            isDotted: false,
            powerIDs: [
                65, 127
            ]
        },
        {
            // possession - command insects
            id: 119,
            isDotted: false,
            powerIDs: [
                65, 12
            ]
        },
        {
            // blood spray - command insects
            id: 120,
            isDotted: false,
            powerIDs: [
                7, 12
            ]
        },
        {
            // spread pathogen - command insects
            id: 121,
            isDotted: true,
            powerIDs: [
                85, 12
            ]
        },
        {
            // spread pathogen - plant communication
            id: 122,
            isDotted: false,
            powerIDs: [
                85, 63
            ]
        },
        {
            // spread pathogen - cure disease
            id: 123,
            isDotted: false,
            powerIDs: [
                85, 15
            ]
        },
        {
            // forced genetic drift - cure disease
            id: 124,
            isDotted: false,
            powerIDs: [
                119, 15
            ]
        },
        {
            // forced genetic drift - disease immunity
            id: 125,
            isDotted: false,
            powerIDs: [
                119, 18
            ]
        },
        {
            // disease immunity - pain immunity
            id: 126,
            isDotted: true,
            powerIDs: [
                18, 61
            ]
        },
        {
            // pain immunity - endorphin control (self)
            id: 127,
            isDotted: false,
            powerIDs: [
                61, 24
            ]
        },
        {
            // addictive personality - endorphin control (self)
            id: 128,
            isDotted: false,
            powerIDs: [
                113, 24
            ]
        },
        {
            // addictive personality - endorphin control (others)
            id: 129,
            isDotted: false,
            powerIDs: [
                113, 23
            ]
        },
        {
            // addictive personality - sexual chemistry
            id: 130,
            isDotted: true,
            powerIDs: [
                113, 78
            ]
        },
        {
            // endorphin control (others) - induce mental disorder
            id: 131,
            isDotted: false,
            powerIDs: [
                23, 45
            ]
        },
        {
            // empathy - endorphin control (others)
            id: 132,
            isDotted: true,
            powerIDs: [
                23, 22
            ]
        },
        {
            // low impulse control - sexual chemistry
            id: 133,
            isDotted: false,
            powerIDs: [
                122, 78
            ]
        },
        {
            // empathy - sexual chemistry
            id: 134,
            isDotted: false,
            powerIDs: [
                22, 78
            ]
        },
        {
            // empathy - nondescript
            id: 135,
            isDotted: false,
            powerIDs: [
                22, 58
            ]
        },
        {
            // empathy - observe dreams
            id: 136,
            isDotted: false,
            powerIDs: [
                22, 59
            ]
        },
        {
            // empathy - translation
            id: 137,
            isDotted: false,
            powerIDs: [
                22, 102
            ]
        },
        {
            // cortisol elevation - induce fear
            id: 138,
            isDotted: false,
            powerIDs: [
                115, 44
            ]
        },
        {
            // induce aggression - induce fear
            id: 139,
            isDotted: false,
            powerIDs: [
                43, 44
            ]
        },
        {
            // induce aggression - induce mental disorder
            id: 140,
            isDotted: true,
            powerIDs: [
                43, 45
            ]
        },
        {
            // plant communication - plant control
            id: 141,
            isDotted: false,
            powerIDs: [
                63, 64
            ]
        },
        {
            // induce mental disorder - meta-persona identify disorder
            id: 142,
            isDotted: true,
            powerIDs: [
                45, 124
            ]
        },
        {
            // enter dreams - meta-persona identify disorder
            id: 143,
            isDotted: false,
            powerIDs: [
                26, 124
            ]
        },
        {
            // observe dreams - meta-persona identify disorder
            id: 144,
            isDotted: false,
            powerIDs: [
                59, 124
            ]
        },
    ]
};

export default data;